import React from 'react';

function sunny() {
  return (
    <div>
      <svg width="208" height="213" viewBox="0 0 208 213" fill="none">
        <g style={{ 'mix-blend-mode': 'multiply' }}>
          <path
            opacity="0.047619"
            d="M156.219 98.1944C143.354 93.0482 142.067 80.1827 153.646 68.6038C160.079 62.1711 170.371 59.598 181.95 60.8845C194.816 63.4576 199.962 72.4634 192.243 84.0424C183.237 95.6213 169.085 102.054 156.219 98.1944Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M156.219 96.9079C143.354 91.7617 142.067 78.8962 153.646 68.6038C160.079 62.1711 170.371 59.598 181.95 60.8845C194.816 62.1711 199.962 72.4634 190.956 84.0424C183.237 94.3348 169.085 102.054 156.219 96.9079Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M157.506 96.9079C144.64 93.0482 143.354 80.1827 154.933 69.8904C161.366 64.7442 171.658 60.8845 181.95 62.1711C193.529 63.4576 198.675 73.75 190.956 84.0424C183.237 94.3348 169.085 100.768 157.506 96.9079Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M157.506 95.6213C144.64 91.7617 144.64 78.8962 154.933 68.6038C161.366 63.4576 170.371 59.598 181.95 62.1711C193.529 64.7442 198.675 73.75 190.956 84.0424C183.237 93.0482 169.085 99.481 157.506 95.6213Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M158.792 95.6213C145.927 91.7617 145.927 78.8962 156.219 69.8904C162.652 64.7442 171.658 62.1711 181.95 63.4576C193.529 64.7442 197.389 73.75 189.669 84.0424C181.95 93.0482 169.085 99.481 158.792 95.6213Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M158.792 94.3348C147.213 90.4751 145.927 78.8962 156.219 69.8904C162.652 64.7442 171.658 62.1711 181.95 63.4576C192.242 64.7442 197.389 73.75 189.669 84.0424C181.95 91.7617 169.085 98.1944 158.792 94.3348Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M158.792 94.3348C147.213 91.7617 145.927 78.8962 156.219 69.8904C162.652 64.7442 171.658 62.1711 180.664 63.4576C190.956 64.7442 196.102 73.75 187.096 82.7558C181.95 91.7617 170.371 96.9079 158.792 94.3348Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M160.079 94.3348C148.5 91.7617 148.5 80.1827 157.506 71.1769C163.938 66.0307 172.944 63.4576 181.95 64.7442C192.243 66.0307 196.102 73.75 188.383 84.0424C180.664 91.7617 170.371 96.9079 160.079 94.3348Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M160.079 93.0482C148.5 90.4751 148.5 78.8962 157.506 71.1769C163.938 66.0307 172.944 63.4576 180.664 64.7442C189.669 66.0307 194.816 73.75 187.096 82.7558C180.664 90.4751 170.371 95.6213 160.079 93.0482Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M160.079 93.0482C148.5 90.4751 148.5 78.8962 157.506 72.4635C165.225 66.0307 172.944 64.7442 181.95 64.7442C190.956 66.0307 194.816 73.75 187.096 82.7558C180.664 90.4751 170.371 94.3348 160.079 93.0482Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M161.366 91.7617C151.073 89.1886 149.787 78.8962 158.792 71.1769C165.225 67.3173 174.231 64.7442 180.664 66.0307C189.67 67.3173 193.529 73.75 185.81 82.7558C180.664 89.1886 170.371 94.3348 161.366 91.7617Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M161.366 91.7617C151.073 90.4751 149.787 78.8962 158.792 72.4634C165.225 67.3173 172.944 66.0307 180.664 67.3173C188.383 68.6038 192.243 75.0365 185.81 82.7558C179.377 89.1886 170.371 93.0482 161.366 91.7617Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M161.365 90.4751C151.073 89.1886 151.073 78.8962 158.792 72.4634C165.225 67.3173 172.944 66.0307 179.377 67.3173C187.096 68.6038 190.956 75.0365 183.237 82.7558C179.377 87.902 170.371 91.7617 161.365 90.4751Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M162.652 90.4751C152.36 89.1886 152.36 78.8962 160.079 72.4635C166.512 67.3173 174.231 66.0307 180.664 67.3173C188.383 68.6038 190.956 73.75 184.523 81.4693C179.377 87.902 171.658 90.4751 162.652 90.4751Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M162.652 89.1886C152.36 87.902 152.36 78.8962 160.079 72.4635C166.512 68.6038 174.231 67.3173 179.377 67.3173C185.81 68.6038 189.669 73.75 181.95 81.4693C178.09 86.6155 171.658 90.4751 162.652 89.1886Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M163.938 89.1886C153.646 87.902 153.646 78.8962 161.365 73.75C167.798 68.6038 175.517 67.3173 180.664 68.6038C187.096 68.6038 190.956 75.0365 183.237 81.4693C178.091 86.6155 171.658 89.1886 163.938 89.1886Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M163.939 87.902C154.933 87.902 153.646 77.6096 161.366 72.4634C167.798 68.6038 175.518 68.6038 180.664 68.6038C187.096 68.6038 189.67 73.75 183.237 81.4693C178.091 86.6155 171.658 87.902 163.939 87.902Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M163.939 87.902C154.933 87.902 154.933 78.8962 161.365 73.75C167.798 69.8903 175.518 68.6038 179.377 68.6038C184.523 68.6038 188.383 73.75 180.664 80.1827C178.091 85.3289 171.658 87.902 163.939 87.902Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M165.225 86.6155C156.219 86.6155 156.219 77.6096 162.652 73.75C169.085 69.8904 175.518 68.6038 180.664 69.8904C185.81 69.8904 188.383 75.0365 181.95 81.4693C176.804 85.3289 171.658 86.6155 165.225 86.6155Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M165.225 86.6155C156.219 86.6155 156.219 78.8962 162.652 75.0366C169.085 71.1769 175.518 71.1769 179.377 71.1769C184.523 71.1769 187.096 76.3231 180.664 81.4693C176.804 84.0424 171.658 85.3289 165.225 86.6155Z"
            fill="#8CA6B4"
          />
          <path
            d="M165.225 85.3289C156.219 86.6155 156.219 77.6096 162.652 73.75C169.085 69.8903 175.518 69.8904 179.377 69.8904C183.237 69.8904 187.096 73.75 179.377 80.1827C176.804 84.0424 172.944 85.3289 165.225 85.3289Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M139.494 62.1711C126.629 68.6038 113.763 57.0249 115.05 41.5863C115.05 32.5805 120.196 23.5746 129.202 15.8553C139.494 8.13605 153.646 17.1419 156.219 30.0074C157.506 44.1594 151.073 57.0249 139.494 62.1711Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M139.494 62.1711C126.629 68.6038 115.05 58.3114 115.05 41.5863C115.05 32.5805 120.196 23.5746 129.202 17.1419C139.494 9.4226 153.646 17.1419 154.933 31.2939C156.219 44.1594 151.073 55.7383 139.494 62.1711Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M139.494 60.8845C126.629 67.3172 115.05 57.0249 115.05 41.5863C116.336 32.5805 121.483 23.5746 129.202 17.1419C139.494 9.4226 152.36 17.1419 153.646 31.2939C156.219 42.8728 149.787 55.7383 139.494 60.8845Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M139.494 59.598C126.629 66.0307 115.05 55.7383 116.336 41.5863C116.336 32.5805 121.482 24.8612 130.488 18.4284C139.494 11.9957 152.36 18.4284 153.646 32.5805C154.933 42.8728 149.787 54.4518 139.494 59.598Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M138.208 58.3114C127.915 64.7441 116.336 55.7383 116.336 40.2997C116.336 31.2939 121.483 23.5746 129.202 17.1419C138.208 10.7091 151.073 17.1419 152.36 30.0074C153.646 42.8728 148.5 53.1652 138.208 58.3114Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M138.208 58.3114C127.915 64.7441 116.336 54.4518 117.623 40.2997C117.623 32.5805 122.769 23.5746 130.488 17.1419C139.494 10.7091 151.073 17.1419 152.36 30.0074C153.646 42.8728 148.5 53.1652 138.208 58.3114Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M138.208 57.0249C127.915 63.4576 116.336 54.4518 117.623 40.2997C118.909 32.5804 122.769 23.5746 130.488 18.4284C138.208 11.9957 149.787 18.4284 151.073 31.2939C152.36 41.5863 147.213 51.8787 138.208 57.0249Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M138.208 55.7383C127.915 62.171 117.623 53.1652 118.909 40.2997C120.196 32.5804 124.056 23.5746 131.775 18.4284C139.494 11.9957 151.073 18.4284 151.073 30.0074C151.073 41.5863 147.213 50.5921 138.208 55.7383Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M138.208 55.7383C127.915 62.171 117.623 53.1652 118.909 40.2997C120.196 32.5804 124.056 24.8612 131.775 19.715C139.494 13.2822 149.787 19.715 151.073 31.2939C151.073 41.5863 145.927 50.5921 138.208 55.7383Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M136.921 54.4517C127.915 60.8845 117.623 51.8787 118.909 40.2997C120.196 32.5804 124.055 24.8612 130.488 19.715C138.207 14.5688 147.213 19.715 148.5 31.2939C149.786 40.2997 145.927 49.3056 136.921 54.4517Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M136.921 53.1652C127.915 59.598 118.909 51.8787 120.196 40.2997C121.482 32.5804 125.342 24.8612 131.775 21.0015C138.208 15.8553 148.5 19.715 148.5 31.2939C149.787 40.2997 145.927 48.019 136.921 53.1652Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M136.921 53.1652C127.915 59.598 118.909 51.8787 120.196 40.2997C121.482 32.5804 126.629 24.8612 131.775 21.0015C138.208 15.8553 147.213 19.715 147.213 31.2939C148.5 40.2997 144.64 48.019 136.921 53.1652Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M136.921 51.8787C127.915 58.3114 118.909 50.5921 121.482 40.2997C122.769 32.5804 127.915 26.1477 133.061 21.0015C139.494 15.8553 147.213 19.715 148.5 31.2939C147.213 39.0132 144.64 46.7325 136.921 51.8787Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M136.921 50.5921C127.915 57.0249 120.196 50.5921 121.482 40.2997C122.769 32.5805 127.915 26.1477 131.775 22.2881C138.208 17.1419 145.927 21.0015 145.927 31.2939C147.213 39.0132 143.354 45.4459 136.921 50.5921Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M135.634 50.5921C127.915 57.0248 120.196 49.3056 122.769 39.0132C124.056 32.5804 127.915 26.1477 133.061 22.2881C138.208 18.4284 145.927 21.0015 145.927 31.2939C145.927 39.0132 143.354 45.4459 135.634 50.5921Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M135.634 49.3056C129.202 55.7383 121.482 49.3056 122.769 39.0132C124.055 32.5804 129.202 26.1477 133.061 22.2881C138.208 18.4284 144.64 21.0015 144.64 31.2939C144.64 37.7266 142.067 44.1594 135.634 49.3056Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M135.634 48.019C129.202 54.4518 121.482 48.019 122.769 39.0132C124.055 31.2939 129.202 26.1477 133.061 22.2881C138.208 18.4284 144.64 21.0015 144.64 31.2939C144.64 37.7266 142.067 42.8728 135.634 48.019Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M135.635 48.019C129.202 54.4518 121.483 48.019 124.056 39.0132C125.342 31.2939 130.488 26.1477 133.061 23.5746C136.921 19.715 143.354 22.2881 143.354 31.2939C143.354 37.7267 140.781 42.8728 135.635 48.019Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M135.635 46.7325C129.202 53.1652 122.769 46.7325 124.056 39.0132C125.342 31.2939 130.488 26.1477 133.062 23.5746C136.921 19.715 142.067 22.2881 142.067 31.2939C143.354 37.7266 140.781 41.5863 135.635 46.7325Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M135.635 45.4459C129.202 53.1652 122.769 46.7325 125.342 39.0132C126.629 31.2939 131.775 26.1477 134.348 23.5746C136.921 21.0015 142.067 22.2881 142.067 31.2939C142.067 36.4401 139.494 40.2997 135.635 45.4459Z"
            fill="#8CA6B4"
          />
          <path
            d="M134.348 45.4459C129.202 51.8787 124.056 45.4459 125.342 39.0132C126.629 31.2939 131.775 26.1477 134.348 24.8612C136.921 21.0015 142.067 22.2881 142.067 31.2939C140.781 36.4401 139.494 40.2997 134.348 45.4459Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M98.3244 46.7325C94.4648 60.8845 80.3127 62.1711 68.7338 51.8787C62.3011 45.4459 58.4414 35.1536 59.728 23.5746C61.0145 10.7092 75.1666 8.13606 88.032 15.8553C98.3244 23.5746 100.898 35.1536 98.3244 46.7325Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M97.0379 46.7325C93.1782 59.598 80.3127 62.1711 68.7338 50.5921C62.3011 45.4459 58.4414 35.1536 59.728 23.5746C61.0145 10.7092 75.1665 9.4226 86.7455 17.1419C97.0379 24.8612 100.897 35.1536 97.0379 46.7325Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M97.0379 46.7325C93.1783 59.598 80.3128 60.8845 70.0204 50.5921C63.5877 44.1594 59.728 35.1536 59.728 23.5746C61.0146 11.9957 73.8801 9.42261 85.459 17.1419C97.0379 24.8612 99.611 35.1536 97.0379 46.7325Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M95.7514 45.4459C93.1783 58.3114 80.3128 59.598 68.7339 49.3056C62.3011 42.8728 59.728 33.867 59.728 23.5746C61.0146 11.9957 73.8801 9.42261 84.1724 17.1419C95.7514 24.8612 98.3245 33.867 95.7514 45.4459Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M95.7515 45.4459C93.1784 58.3114 80.3129 59.598 70.0205 49.3056C63.5878 42.8728 61.0147 33.867 61.0147 23.5746C62.3012 11.9957 75.1667 10.7092 85.4591 17.1419C94.4649 24.8612 98.3246 33.867 95.7515 45.4459Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M94.4649 45.4459C91.8918 58.3114 79.0263 59.598 70.0205 49.3056C63.5878 42.8728 61.0147 33.867 61.0147 24.8612C62.3012 14.5688 73.8802 11.9957 84.1725 19.715C94.4649 24.8612 97.038 33.867 94.4649 45.4459Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M94.4649 45.4459C91.8918 57.0249 80.3129 58.3114 71.3071 49.3056C64.8743 42.8729 61.0147 33.867 62.3012 24.8612C63.5878 14.5688 75.1667 11.9957 84.1725 19.715C93.1784 24.8612 95.7515 33.867 94.4649 45.4459Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M93.1784 44.1594C90.6053 55.7383 79.0264 57.0249 70.0206 48.019C64.8744 41.5863 62.3013 33.867 62.3013 24.8612C63.5878 14.5688 73.8802 11.9957 84.1726 19.715C93.1784 26.1477 95.7515 33.867 93.1784 44.1594Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M93.1782 44.1594C91.8916 55.7383 80.3127 57.0249 71.3069 48.019C64.8741 41.5863 62.3011 32.5805 63.5876 24.8612C63.5876 15.8553 75.1665 13.2822 84.1724 19.715C91.8916 26.1477 94.4647 33.867 93.1782 44.1594Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M91.892 44.1594C90.6054 55.7383 79.0265 57.0249 71.3072 48.019C66.161 41.5863 63.5879 32.5805 63.5879 24.8612C63.5879 15.8554 73.8803 13.2823 82.8861 21.0015C90.6054 26.1477 93.1785 33.867 91.892 44.1594Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M91.892 42.8729C90.6054 54.4518 79.0265 55.7383 71.3072 46.7325C66.161 40.2998 63.5879 32.5805 63.5879 24.8612C64.8745 15.8554 73.8803 13.2823 82.8861 21.0015C90.6054 26.1477 91.892 33.867 91.892 42.8729Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M90.6051 42.8728C89.3186 53.1652 79.0262 54.4518 71.3069 46.7325C66.1607 40.2997 63.5876 32.5805 64.8742 24.8612C64.8742 17.1419 73.88 14.5688 82.8858 21.0015C89.3186 26.1477 91.8917 33.867 90.6051 42.8728Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M90.6051 42.8728C89.3186 53.1652 79.0262 54.4518 71.3069 45.4459C66.1607 40.2997 64.8741 31.2939 64.8741 24.8612C64.8741 17.1419 73.88 14.5688 81.5993 21.0015C88.032 26.1477 90.6051 32.5805 90.6051 42.8728Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M89.3186 41.5863C89.3186 51.8787 79.0262 53.1652 72.5935 45.4459C67.4473 39.0132 64.8742 31.2939 64.8742 24.8612C64.8742 17.1419 72.5935 14.5688 81.5993 22.2881C88.032 27.4343 89.3186 32.5805 89.3186 41.5863Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M89.3186 41.5863C88.0321 51.8787 79.0262 51.8787 72.5935 44.1594C67.4473 39.0132 66.1608 31.2939 66.1608 24.8612C66.1608 18.4284 73.8801 15.8553 81.5993 22.2881C86.7455 27.4343 89.3186 32.5805 89.3186 41.5863Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M88.0321 41.5863C88.0321 51.8787 79.0262 51.8787 72.5935 44.1594C67.4473 37.7267 66.1608 30.0074 66.1608 24.8612C66.1608 18.4284 72.5935 15.8553 80.3128 22.2881C86.7455 27.4343 88.0321 32.5805 88.0321 41.5863Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M86.7455 40.2997C86.7455 49.3056 77.7397 50.5921 72.5935 42.8728C67.4473 36.4401 66.1608 30.0074 66.1608 24.8612C66.1608 18.4284 72.5935 15.8553 80.3128 22.2881C85.459 27.4343 86.7455 32.5805 86.7455 40.2997Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M86.7455 40.2997C86.7455 49.3056 77.7397 50.5921 72.5935 42.8728C67.4473 36.4401 66.1608 30.0074 66.1608 24.8612C66.1608 19.715 71.307 15.8553 79.0262 22.2881C84.1724 27.4343 86.7455 32.5805 86.7455 40.2997Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M85.4591 40.2997C86.7456 49.3056 77.7398 49.3056 72.5936 42.8728C68.734 36.4401 67.4474 30.0074 67.4474 26.1477C67.4474 21.0015 72.5936 18.4284 79.0263 24.8612C84.1725 27.4343 85.4591 32.5805 85.4591 40.2997Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M85.4591 39.0132C86.7457 48.019 77.7398 48.019 73.8802 42.8728C68.734 36.4401 68.734 28.7208 68.734 26.1477C68.734 21.0015 72.5936 18.4284 80.3129 24.8612C82.886 27.4343 84.1726 32.5805 85.4591 39.0132Z"
            fill="#8CA6B4"
          />
          <path
            d="M84.1726 39.0132C85.4591 48.019 77.7398 48.019 73.8802 41.5863C70.0206 35.1536 68.734 28.7208 68.734 26.1477C68.734 22.2881 72.5936 18.4284 79.0264 24.8612C82.886 28.7208 84.1726 32.5805 84.1726 39.0132Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M145.927 139.364C139.494 126.498 147.213 116.206 163.938 116.206C172.944 116.206 181.95 120.066 189.669 129.072C197.389 139.364 194.816 150.943 181.95 153.516C169.085 154.802 152.36 150.943 145.927 139.364Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M147.213 139.364C140.781 126.498 148.5 116.206 163.938 116.206C172.944 116.206 181.95 120.066 189.669 129.072C197.389 139.364 194.816 149.656 181.95 152.229C169.085 154.802 153.646 149.656 147.213 139.364Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M147.213 138.077C140.781 126.498 148.5 116.206 163.938 116.206C172.944 116.206 181.95 120.066 188.383 129.072C196.102 138.077 193.529 148.37 180.664 150.943C169.085 153.516 153.646 149.656 147.213 138.077Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M148.5 138.077C142.067 126.498 149.786 116.206 165.225 116.206C174.231 116.206 183.237 120.066 189.669 129.072C197.389 138.077 194.816 148.37 181.95 150.943C169.085 153.516 154.933 148.37 148.5 138.077Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M149.786 138.077C143.354 126.498 151.073 117.493 165.225 117.493C174.231 117.493 181.95 121.352 189.669 129.072C197.389 138.077 194.815 147.083 181.95 149.656C169.084 152.229 154.932 148.37 149.786 138.077Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M149.786 138.077C143.354 127.785 151.073 117.493 165.225 117.493C172.944 117.493 181.95 121.352 188.383 129.072C194.815 136.791 193.529 147.083 180.663 148.37C169.084 152.229 156.219 148.37 149.786 138.077Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M151.073 138.077C144.64 127.785 152.36 118.779 165.225 118.779C172.944 118.779 181.95 122.639 188.383 130.358C194.816 138.077 193.529 147.083 180.664 149.656C169.085 150.943 156.219 147.083 151.073 138.077Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M151.073 138.077C144.64 127.785 151.073 118.779 165.225 120.066C172.944 120.066 181.95 125.212 187.096 131.645C193.529 139.364 192.242 148.37 179.377 149.656C169.085 150.943 157.506 147.083 151.073 138.077Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M152.359 138.077C145.927 129.072 152.359 120.066 165.225 120.066C172.944 120.066 181.95 125.212 187.096 131.645C193.529 139.364 190.956 147.083 179.377 149.656C169.085 149.656 158.792 145.797 152.359 138.077Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M153.646 138.077C147.213 129.072 153.646 120.066 166.512 121.352C174.231 121.352 181.95 126.498 187.096 131.645C193.529 138.077 190.956 147.083 179.377 148.37C169.085 149.656 158.792 145.797 153.646 138.077Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M153.646 136.791C147.213 127.785 153.646 120.066 165.225 120.066C172.944 120.066 180.663 125.212 185.81 130.358C190.956 136.791 189.669 144.51 178.09 145.797C169.084 148.37 160.079 145.797 153.646 136.791Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M154.933 136.791C148.5 127.785 154.933 120.066 166.511 121.352C174.231 121.352 181.95 126.498 187.096 131.645C192.242 138.077 190.956 145.797 179.377 147.083C170.371 147.083 160.079 144.51 154.933 136.791Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M154.932 136.791C148.5 129.072 154.932 120.066 165.225 121.352C172.944 122.639 180.663 126.498 184.523 131.645C189.669 138.077 188.383 144.51 176.804 145.797C170.371 147.083 161.365 144.51 154.932 136.791Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M156.219 136.791C149.786 129.072 156.219 121.352 166.511 122.639C174.231 123.925 180.663 127.785 185.81 132.931C190.956 138.077 189.669 145.797 179.377 145.797C170.371 145.797 161.365 143.224 156.219 136.791Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M157.506 136.791C151.073 129.072 157.506 121.352 166.512 122.639C174.231 123.925 180.664 127.785 184.523 131.645C189.67 136.791 188.383 143.224 178.091 144.51C170.371 145.797 162.652 143.224 157.506 136.791Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M157.506 136.791C151.073 130.358 157.506 122.639 166.512 123.925C174.231 125.212 180.664 129.072 184.523 132.931C188.383 138.077 188.383 144.51 178.091 144.51C170.371 144.51 163.939 141.937 157.506 136.791Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M158.792 136.791C152.359 130.358 157.506 122.639 166.511 123.925C174.231 125.212 180.663 129.072 183.237 132.931C187.096 136.791 185.81 143.224 176.804 144.51C170.371 144.51 163.938 141.937 158.792 136.791Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M158.792 136.791C152.359 130.358 157.506 123.925 166.511 125.212C174.231 126.498 179.377 130.358 183.237 134.218C187.096 138.077 185.81 144.51 176.804 144.51C170.371 143.224 165.225 141.937 158.792 136.791Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M160.079 136.791C153.646 130.358 158.792 123.925 166.511 125.212C174.231 126.498 179.377 130.358 181.95 132.931C185.81 136.791 184.523 141.937 175.517 141.937C170.371 143.224 165.225 140.65 160.079 136.791Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M160.079 135.504C153.646 130.358 158.792 123.925 166.511 125.212C174.231 126.498 179.377 130.358 181.95 132.931C185.81 136.791 184.523 141.937 175.517 141.937C170.371 141.937 166.511 140.65 160.079 135.504Z"
            fill="#8CA6B4"
          />
          <path
            d="M161.365 135.504C154.933 130.358 160.079 125.212 167.798 126.498C175.517 127.785 180.664 131.645 183.237 134.218C187.096 136.791 185.81 141.937 176.804 141.937C170.371 141.937 166.511 139.364 161.365 135.504Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M112.477 159.949C116.336 147.083 130.488 144.51 142.067 156.089C148.5 162.522 152.36 171.528 151.073 184.393C149.786 197.259 139.494 203.691 127.915 194.685C117.623 186.966 108.617 172.814 112.477 159.949Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M113.763 159.949C117.623 147.083 130.488 145.797 142.067 156.089C148.5 162.522 152.36 171.528 151.073 183.107C149.787 195.972 139.494 201.118 129.202 193.399C117.623 186.966 109.904 172.814 113.763 159.949Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M113.763 159.949C117.623 147.083 130.488 145.797 140.781 156.089C147.213 162.522 149.787 171.528 149.787 183.107C148.5 194.685 139.494 201.118 127.915 193.399C117.623 185.68 111.19 172.814 113.763 159.949Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M115.05 161.235C118.909 148.37 131.775 147.083 142.067 157.376C148.5 163.808 151.073 172.814 149.786 183.107C148.5 194.685 139.494 201.118 129.202 193.399C118.909 185.68 111.19 172.814 115.05 161.235Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M115.05 161.235C117.623 148.37 130.488 147.083 140.781 157.376C147.214 163.808 149.787 172.814 148.5 181.82C147.214 193.399 138.208 198.545 127.915 190.826C118.91 184.393 112.477 172.814 115.05 161.235Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M116.336 161.235C118.91 149.656 131.775 148.37 142.067 158.662C147.214 165.095 151.073 172.814 149.787 183.107C148.5 193.399 140.781 199.832 130.488 192.112C118.91 184.393 112.477 172.814 116.336 161.235Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M116.336 161.235C118.909 149.656 131.775 148.37 140.781 158.662C145.927 165.095 148.5 172.814 148.5 181.82C147.213 192.112 139.494 197.259 129.202 190.826C120.196 184.393 113.763 172.814 116.336 161.235Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M116.336 161.235C118.909 149.656 130.488 148.37 139.494 158.662C144.64 165.095 147.213 172.814 147.213 181.82C145.927 192.112 138.208 197.259 127.915 189.539C120.196 183.107 115.05 172.814 116.336 161.235Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M117.623 162.522C120.196 150.943 131.775 149.656 140.781 159.949C145.927 166.381 148.5 174.101 147.213 181.82C145.927 190.826 138.207 197.259 129.202 189.539C120.196 183.107 115.05 172.814 117.623 162.522Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M117.623 162.522C118.909 150.943 131.775 150.943 139.494 159.949C144.64 166.381 147.213 174.101 145.927 181.82C144.64 190.826 138.208 195.972 127.915 189.539C121.483 181.82 116.336 172.814 117.623 162.522Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M118.909 162.522C120.196 150.943 131.775 150.943 139.494 159.949C144.64 166.381 147.213 172.814 145.927 180.533C144.64 189.539 138.207 194.685 129.202 186.966C121.482 181.82 116.336 172.814 118.909 162.522Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M118.909 162.522C120.196 152.229 131.775 150.943 139.494 159.949C144.64 166.381 145.927 172.814 145.927 180.533C145.927 188.253 138.207 193.399 129.202 186.966C121.482 180.533 117.623 171.528 118.909 162.522Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M118.909 162.522C120.196 152.229 131.775 150.943 138.208 159.949C143.354 166.381 144.64 172.814 144.64 179.247C144.64 186.966 136.921 192.112 129.202 185.68C122.769 180.533 118.909 171.528 118.909 162.522Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M120.196 163.808C121.482 153.516 131.775 153.516 138.208 161.235C143.354 167.668 144.64 174.101 144.64 180.533C144.64 188.253 138.208 193.399 129.202 185.68C122.769 179.247 118.909 171.528 120.196 163.808Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M120.196 163.808C120.196 153.516 131.775 153.516 138.208 161.235C143.354 167.668 144.64 174.101 143.354 179.247C143.354 185.68 136.921 190.826 129.202 184.393C122.769 179.247 120.196 171.528 120.196 163.808Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M121.483 163.808C121.483 153.516 131.775 153.516 138.208 161.235C143.354 167.668 143.354 172.814 143.354 177.96C143.354 184.393 136.921 189.539 129.202 183.107C124.056 179.247 120.196 171.528 121.483 163.808Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M121.483 163.808C121.483 154.802 131.775 153.516 136.921 161.235C142.067 167.668 142.067 174.101 142.067 177.96C142.067 184.393 135.635 188.253 129.202 181.82C124.056 177.96 121.483 171.528 121.483 163.808Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M121.483 165.095C121.483 156.089 131.775 156.089 136.921 162.522C140.781 168.955 142.067 174.101 142.067 177.96C142.067 183.107 136.921 188.253 129.202 181.82C124.056 177.96 122.769 171.528 121.483 165.095Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M122.769 165.095C122.769 156.089 131.775 156.089 136.921 162.522C140.781 168.955 142.067 174.101 142.067 177.96C142.067 183.107 136.921 188.253 130.488 181.82C125.342 176.674 122.769 171.528 122.769 165.095Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M122.769 165.095C121.482 156.089 131.775 156.089 135.634 162.522C139.494 168.955 139.494 174.101 139.494 176.674C139.494 181.82 134.348 185.68 127.915 179.247C125.342 176.674 124.056 171.528 122.769 165.095Z"
            fill="#8CA6B4"
          />
          <path
            d="M124.056 165.095C122.769 156.089 133.061 157.376 136.921 162.522C140.781 168.955 140.781 172.814 140.781 176.674C140.781 180.533 135.635 185.68 129.202 179.247C125.342 175.387 124.056 171.528 124.056 165.095Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M72.5937 153.516C84.1727 147.083 95.7516 153.516 97.0381 170.241C97.0381 179.247 94.465 189.539 85.4592 197.259C75.1668 206.264 64.8745 203.691 61.0148 189.539C57.1552 176.674 61.0148 159.949 72.5937 153.516Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M72.5937 154.802C84.1727 148.37 94.465 154.802 95.7516 171.528C95.7516 180.533 91.892 189.539 84.1727 197.259C75.1668 206.264 63.5879 203.691 61.0148 190.826C57.1552 176.674 61.0148 161.235 72.5937 154.802Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M72.5936 154.803C84.1726 148.37 94.4649 154.803 95.7515 170.241C95.7515 179.247 91.8918 188.253 84.1726 195.972C75.1667 203.691 64.8743 202.405 61.0147 189.539C58.4416 176.674 62.3012 161.235 72.5936 154.803Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M72.5936 154.803C82.886 148.37 93.1784 154.803 94.4649 170.241C94.4649 179.247 90.6053 188.253 82.886 194.685C73.8802 202.405 63.5878 201.118 61.0147 188.253C58.4416 176.674 62.3012 161.235 72.5936 154.803Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M72.5937 156.089C82.8861 149.656 93.1785 156.089 93.1785 170.241C93.1785 177.96 89.3188 188.253 82.8861 194.685C75.1668 202.405 64.8744 201.118 62.3013 188.253C59.7282 176.674 63.5879 161.235 72.5937 156.089Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M72.5937 156.089C82.8861 149.656 91.8919 156.089 93.1785 170.241C93.1785 177.96 89.3188 186.966 82.8861 193.399C75.1668 201.118 64.8744 199.832 62.3013 186.966C59.7282 175.387 63.5879 162.522 72.5937 156.089Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M72.5937 157.376C81.5996 150.943 91.8919 157.376 91.8919 170.241C91.8919 177.96 88.0323 186.966 81.5996 193.399C73.8803 201.118 64.8744 198.545 62.3013 186.966C61.0148 175.387 63.5879 162.522 72.5937 157.376Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M72.5936 157.376C81.5994 150.943 90.6053 156.089 91.8918 170.241C91.8918 177.96 88.0322 186.966 81.5995 193.399C73.8802 199.832 64.8743 198.545 62.3012 186.966C61.0147 175.387 64.8743 162.522 72.5936 157.376Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M72.5936 157.376C81.5995 152.229 90.6053 156.089 90.6053 168.955C90.6053 176.674 86.7456 185.68 80.3129 190.826C73.8802 197.259 64.8743 195.972 62.3012 184.393C62.3012 175.387 64.8743 163.808 72.5936 157.376Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M73.8803 158.662C81.5996 152.229 90.6054 157.376 90.6054 168.955C90.6054 176.674 86.7458 184.393 81.5996 190.826C75.1669 197.259 66.161 195.972 64.8745 184.393C62.3014 175.387 66.161 163.808 73.8803 158.662Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M73.8802 158.662C81.5995 153.516 90.6053 157.376 90.6053 168.955C90.6053 176.674 86.7457 184.393 81.5995 189.539C75.1667 195.972 67.4475 194.685 64.8744 183.107C63.5878 175.387 66.1609 163.808 73.8802 158.662Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M73.8802 159.949C81.5995 154.802 89.3188 158.662 89.3188 170.241C89.3188 177.96 85.4591 185.68 80.313 190.826C73.8802 195.972 66.1609 195.972 64.8744 184.393C63.5878 175.387 66.1609 163.808 73.8802 159.949Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M73.8801 159.949C80.3129 154.802 89.3187 158.662 89.3187 168.955C89.3187 176.674 85.4591 184.393 80.3129 188.253C75.1667 193.399 67.4474 193.399 66.1608 181.82C64.8743 174.101 67.4474 165.095 73.8801 159.949Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M73.8801 159.949C80.3129 154.802 88.0322 157.376 88.0322 168.955C88.0322 176.674 84.1725 183.107 80.3129 188.253C75.1667 193.399 67.4474 193.399 66.1608 183.107C64.8743 174.101 67.4474 165.095 73.8801 159.949Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M73.8801 161.235C80.3129 156.089 88.0321 158.662 88.0321 168.955C88.0321 176.674 84.1725 183.107 80.3129 186.966C75.1667 192.112 68.7339 192.112 67.4474 181.82C64.8743 174.101 68.7339 165.095 73.8801 161.235Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M73.88 161.235C79.0262 156.089 86.7455 158.662 86.7455 167.668C86.7455 175.387 82.8859 181.82 79.0262 185.68C73.88 190.826 67.4473 190.826 66.1607 180.533C66.1607 174.101 68.7338 166.381 73.88 161.235Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M73.8801 162.522C79.0263 158.662 85.4591 159.949 86.7456 168.955C86.7456 176.674 82.886 183.107 79.0263 185.68C75.1667 189.539 68.7339 190.826 67.4474 180.533C66.1608 174.101 68.7339 166.381 73.8801 162.522Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M73.8801 162.522C79.0263 158.662 85.4591 159.949 85.4591 167.668C85.4591 175.387 81.5994 180.533 77.7398 184.393C73.8801 188.253 67.4474 188.253 67.4474 179.247C67.4474 174.101 70.0205 166.381 73.8801 162.522Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M73.8801 162.522C77.7398 158.662 84.1725 159.949 84.1725 167.668C84.1725 175.387 80.3129 180.533 77.7398 184.393C73.8801 188.253 68.7339 188.253 67.4474 179.247C67.4474 172.814 70.0205 166.381 73.8801 162.522Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M73.8802 163.808C77.7398 159.949 84.1725 159.949 84.1725 167.668C84.1725 174.101 80.3129 180.533 77.7398 183.107C73.8802 186.966 68.734 186.966 68.734 177.96C68.734 172.814 71.3071 167.668 73.8802 163.808Z"
            fill="#8CA6B4"
          />
          <path
            d="M73.8802 163.808C77.7398 159.949 84.1725 161.235 84.1725 167.668C84.1725 174.101 80.3129 180.533 77.7398 183.107C75.1667 186.966 70.0205 186.966 68.734 177.96C68.734 172.814 71.3071 167.668 73.8802 163.808Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M48.149 118.779C62.301 121.352 66.1607 131.645 55.8683 145.797C50.7221 153.516 40.4297 156.089 27.5643 157.376C14.6988 158.662 6.9795 149.656 13.4122 136.791C19.845 122.639 35.2835 116.206 48.149 118.779Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M46.8628 118.779C59.7282 121.352 63.5879 131.645 54.5821 144.51C50.7224 150.943 39.1435 154.802 27.5646 154.802C14.6991 156.089 8.26635 147.083 13.4125 134.218C19.8453 123.925 35.2838 117.493 46.8628 118.779Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M46.8627 118.779C59.7281 120.066 63.5878 130.358 54.5819 143.224C49.4357 150.943 39.1434 153.516 27.5644 154.802C15.9855 156.089 8.26623 147.083 14.699 135.504C21.1317 123.925 35.2837 117.493 46.8627 118.779Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M46.8626 120.066C59.7281 121.352 63.5877 131.645 54.5819 143.224C49.4357 149.656 39.1433 153.516 28.8509 153.516C17.272 154.802 10.8393 145.797 15.9855 134.218C21.1316 123.925 35.2837 117.493 46.8626 120.066Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M46.8628 120.066C58.4417 121.352 62.3013 130.358 54.5821 143.224C49.4359 149.656 39.1435 153.516 28.8511 153.516C17.2722 154.802 10.8394 147.083 17.2722 135.504C22.4184 123.925 35.2838 118.779 46.8628 120.066Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M45.576 120.066C57.1549 121.352 61.0145 130.358 53.2953 141.937C48.1491 148.37 37.8567 152.229 28.8509 152.229C18.5585 153.516 10.8392 145.797 17.2719 134.218C22.4181 123.925 35.2836 118.779 45.576 120.066Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M45.5762 120.066C57.1551 121.352 61.0148 130.358 53.2955 140.65C48.1493 147.083 39.1435 149.656 28.8511 150.943C18.5587 152.229 12.126 144.51 17.2722 134.218C23.7049 123.925 35.2838 120.066 45.5762 120.066Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M45.5762 121.352C55.8686 122.639 59.7282 130.358 52.0089 140.65C46.8627 147.083 37.8569 149.656 28.8511 150.943C18.5587 152.229 12.1259 144.51 18.5587 134.218C23.7049 125.212 35.2838 120.066 45.5762 121.352Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M45.5761 121.352C55.8685 122.639 59.7282 130.358 52.0089 140.65C46.8627 147.083 37.8568 149.656 30.1376 150.943C21.1317 152.229 14.699 145.797 19.8452 134.218C23.7048 125.212 35.2837 120.066 45.5761 121.352Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M44.2895 121.352C54.5818 122.639 58.4415 129.072 50.7222 139.364C45.576 145.797 36.5702 148.37 28.8509 149.656C19.8451 150.943 13.4123 144.51 19.8451 134.218C24.9912 125.212 35.2836 121.352 44.2895 121.352Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M44.2894 122.639C53.2953 123.925 57.1549 130.358 50.7222 139.364C45.576 145.797 36.5702 148.37 30.1374 148.37C21.1316 149.656 15.9854 143.224 21.1316 132.931C24.9912 125.212 35.2836 121.352 44.2894 122.639Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M44.2894 122.639C53.2952 122.639 57.1549 129.072 50.7221 138.077C45.5759 144.51 37.8566 147.083 30.1374 147.083C22.4181 148.37 15.9853 141.937 22.4181 132.931C26.2777 125.212 35.2836 121.352 44.2894 122.639Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M44.2896 122.639C53.2955 122.639 57.1551 129.072 50.7224 138.077C45.5762 144.51 37.8569 147.083 31.4242 147.083C23.7049 148.37 18.5587 143.224 23.7049 132.931C26.278 126.498 35.2838 122.639 44.2896 122.639Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M43.003 122.639C50.7223 122.639 55.8685 127.785 49.4357 136.791C44.2895 143.224 36.5703 144.51 30.1375 145.797C22.4182 147.083 17.2721 141.937 22.4182 132.931C27.5644 126.498 36.5703 122.639 43.003 122.639Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M43.003 123.925C50.7223 123.925 54.582 129.072 48.1492 136.791C43.003 143.224 35.2838 144.51 30.1376 145.797C23.7048 147.083 18.5586 141.937 23.7048 132.931C27.5645 126.498 36.5703 123.925 43.003 123.925Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M43.003 123.925C50.7223 123.925 54.582 127.785 48.1492 135.504C44.2896 141.937 35.2838 143.224 30.1376 144.51C23.7048 145.797 18.5586 140.65 23.7048 132.931C28.851 126.498 36.5703 123.925 43.003 123.925Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M43.0029 123.925C49.4357 123.925 54.5819 127.785 48.1491 135.504C44.2895 140.65 36.5702 143.224 31.424 144.51C24.9913 145.797 19.8451 141.937 26.2778 132.931C28.8509 126.498 36.5702 123.925 43.0029 123.925Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M41.7163 125.212C48.149 125.212 52.0087 129.072 46.8625 135.504C43.0028 140.65 35.2835 143.224 30.1373 143.224C24.9911 144.51 19.845 140.65 24.9911 132.931C30.1373 126.498 36.5701 125.212 41.7163 125.212Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M41.7164 125.212C48.1491 125.212 52.0088 127.785 46.8626 134.218C43.0029 139.364 35.2836 141.937 31.424 141.937C26.2778 143.224 21.1316 139.364 26.2778 131.645C30.1374 127.785 36.5702 125.212 41.7164 125.212Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M41.7166 125.212C46.8628 125.212 52.009 127.785 46.8628 132.931C43.0031 138.077 35.2838 140.65 31.4242 140.65C26.278 141.937 22.4184 139.364 27.5645 131.645C30.1376 127.785 36.5704 126.498 41.7166 125.212Z"
            fill="#8CA6B4"
          />
          <path
            d="M41.7164 126.498C46.8626 125.212 50.7222 127.785 46.8626 134.218C43.0029 139.364 35.2837 141.937 32.7106 141.937C28.8509 143.224 23.7047 140.65 28.8509 132.931C31.424 127.785 36.5702 126.498 41.7164 126.498Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M152.36 122.639C140.781 112.346 144.64 96.9079 162.652 90.4751C171.658 86.6155 184.523 87.902 196.102 94.3348C208.968 102.054 210.254 114.92 196.102 123.925C181.95 131.645 162.652 132.931 152.36 122.639Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M152.36 121.352C140.781 111.06 144.64 96.9079 162.652 90.4751C171.658 86.6155 184.523 87.902 196.102 94.3348C208.968 102.054 210.254 114.92 196.102 122.639C181.95 130.358 163.938 131.645 152.36 121.352Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M153.646 121.352C142.067 111.06 145.927 96.9078 162.652 90.4751C171.658 86.6155 183.237 87.902 194.816 94.3348C206.395 100.767 208.968 113.633 194.816 121.352C181.95 129.072 163.939 130.358 153.646 121.352Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M153.646 121.352C142.067 111.06 147.213 98.1944 162.652 91.7617C171.658 87.902 183.237 89.1886 193.529 95.6213C205.108 102.054 206.395 114.92 193.529 122.639C181.95 129.072 165.225 130.358 153.646 121.352Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M154.933 120.066C143.354 111.06 148.5 96.9078 163.939 91.7617C172.945 89.1886 184.523 89.1886 194.816 95.6213C206.395 102.054 207.681 113.633 194.816 121.352C181.95 127.785 165.225 129.072 154.933 120.066Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M156.219 120.066C144.64 111.06 149.786 98.1944 163.938 93.0482C172.944 89.1886 184.523 90.4751 193.529 95.6213C205.108 102.054 206.395 113.633 193.529 121.352C181.95 126.498 166.512 127.785 156.219 120.066Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M156.219 120.066C144.64 111.06 149.786 98.1944 163.938 93.0482C172.944 90.4751 184.523 91.7617 193.529 96.9078C203.821 103.341 205.108 113.633 192.243 120.066C181.95 126.498 166.512 127.785 156.219 120.066Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M157.506 118.779C145.927 111.06 151.073 98.1944 165.225 93.0482C174.231 90.4751 184.523 91.7617 193.529 96.9078C203.822 102.054 205.108 113.633 192.243 120.066C181.95 125.212 166.512 126.498 157.506 118.779Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M157.506 118.779C145.927 111.06 151.073 98.1944 165.225 94.3348C174.231 91.7617 184.523 93.0482 193.529 98.1944C202.535 103.341 203.822 113.633 192.243 120.066C180.664 125.212 167.798 125.212 157.506 118.779Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M158.793 117.493C148.5 109.773 152.36 98.1944 165.225 94.3348C174.231 91.7617 184.523 93.0482 192.243 98.1944C201.249 103.341 202.535 112.346 190.956 118.779C180.664 123.925 167.798 125.212 158.793 117.493Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M160.079 117.493C149.787 111.06 153.646 98.1944 166.512 94.3348C175.518 91.7617 185.81 93.0482 193.529 98.1944C202.535 103.341 203.822 112.346 192.243 118.779C180.664 123.925 169.085 123.925 160.079 117.493Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M160.079 117.493C149.787 111.06 153.646 99.4809 166.512 95.6213C175.518 93.0482 184.524 95.6213 192.243 99.4809C201.249 104.627 201.249 112.346 189.67 118.779C180.664 122.639 169.085 122.639 160.079 117.493Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M161.365 116.206C151.073 109.773 154.933 98.1944 166.512 95.6213C175.517 93.0482 184.523 95.6213 190.956 98.1944C198.675 102.054 199.962 111.06 188.383 116.206C180.664 121.352 170.371 122.639 161.365 116.206Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M161.365 116.206C151.073 111.06 154.933 99.4809 166.512 96.9078C175.517 94.3347 184.523 96.9078 190.956 99.4809C198.675 103.341 199.962 111.06 188.383 116.206C180.664 121.352 170.371 121.352 161.365 116.206Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M162.652 116.206C152.36 111.06 156.219 100.767 167.798 96.9078C176.804 94.3347 185.81 96.9078 190.956 99.4809C198.675 103.341 198.675 111.06 188.383 116.206C180.664 120.066 171.658 120.066 162.652 116.206Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M163.939 114.92C153.646 109.773 157.506 99.4809 167.798 96.9078C176.804 94.3347 184.523 96.9078 190.956 99.4809C197.389 103.341 198.675 109.773 188.383 114.92C180.664 120.066 171.658 120.066 163.939 114.92Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M163.939 114.92C153.646 109.773 157.506 100.767 167.798 98.1944C176.804 96.9078 184.523 98.1944 189.67 100.767C196.102 103.341 197.389 111.06 187.096 114.92C180.664 118.779 172.944 118.779 163.939 114.92Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M165.225 114.92C154.933 111.06 158.793 100.767 169.085 99.4809C178.091 98.1944 185.81 99.4809 190.956 102.054C197.389 104.627 197.389 111.06 187.097 116.206C179.377 117.493 172.945 117.493 165.225 114.92Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M165.225 113.633C154.933 109.773 158.793 100.767 169.085 98.1944C178.091 96.9078 185.81 99.4809 189.67 100.767C194.816 103.341 196.102 109.773 185.81 113.633C179.377 117.493 172.945 117.493 165.225 113.633Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M166.512 113.633C156.219 109.773 160.079 100.767 169.085 99.4809C178.091 98.1944 185.81 100.767 188.383 102.054C193.529 104.627 194.816 109.773 184.523 113.633C179.377 116.206 174.231 116.206 166.512 113.633Z"
            fill="#8CA6B4"
          />
          <path
            d="M167.798 112.346C158.792 109.773 161.366 100.767 170.371 99.4809C179.377 98.1944 185.81 100.767 189.67 102.054C194.816 104.627 196.102 109.773 185.81 113.633C179.377 116.206 174.231 114.92 167.798 112.346Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M149.787 82.7558C133.061 82.7558 126.629 68.6038 135.635 51.8787C139.494 42.8729 149.787 35.1536 162.652 32.5805C176.804 30.0074 188.383 41.5863 183.237 57.0249C178.091 72.4635 165.225 82.7558 149.787 82.7558Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M149.787 81.4693C134.348 81.4693 127.915 67.3173 135.635 51.8787C139.494 42.8729 149.787 35.1536 162.652 32.5805C176.804 30.0074 187.096 41.5863 181.95 57.0249C178.091 71.1769 163.939 81.4693 149.787 81.4693Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M149.787 80.1827C134.348 80.1827 127.915 67.3173 135.635 51.8787C140.781 42.8729 149.787 36.4401 161.366 32.5805C175.518 30.0074 184.523 41.5863 180.664 55.7383C176.804 71.1769 163.939 80.1827 149.787 80.1827Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M149.787 80.1827C134.348 81.4693 129.202 67.3173 136.921 51.8787C142.067 42.8728 151.073 36.4401 162.652 33.867C175.518 31.2939 185.81 41.5863 180.664 57.0249C176.804 69.8904 163.939 78.8962 149.787 80.1827Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M151.073 78.8962C136.921 80.1827 130.489 66.0307 138.208 51.8787C143.354 42.8728 152.36 36.4401 163.939 33.867C176.804 31.2939 185.81 41.5863 180.664 55.7383C175.518 68.6038 163.939 77.6096 151.073 78.8962Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M151.073 77.6096C136.921 78.8962 130.489 66.0307 138.208 51.8787C143.354 42.8728 152.36 36.4401 162.652 33.867C175.518 31.2939 183.237 41.5863 179.377 55.7383C175.518 68.6038 163.939 77.6096 151.073 77.6096Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M151.073 77.6096C136.921 78.8962 131.775 66.0307 139.494 53.1652C144.641 45.4459 153.646 39.0132 163.939 36.4401C175.518 33.867 184.523 42.8728 179.377 57.0249C174.231 67.3173 163.939 76.3231 151.073 77.6096Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M151.073 76.3231C136.921 77.6096 131.775 66.0307 139.494 51.8787C144.641 44.1594 152.36 37.7266 162.652 35.1535C174.231 32.5805 181.95 41.5863 178.091 55.7383C174.231 67.3172 163.939 75.0365 151.073 76.3231Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M151.073 75.0365C138.208 76.3231 131.775 64.7442 139.494 51.8787C144.64 44.1594 152.36 37.7267 162.652 35.1536C172.945 32.5805 181.95 41.5863 176.804 54.4518C172.945 66.0307 163.939 73.75 151.073 75.0365Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M152.36 75.0365C139.494 77.6096 134.348 64.7442 140.781 53.1652C145.927 45.4459 153.646 39.0132 162.652 37.7267C172.944 35.1536 180.664 44.1594 175.517 55.7383C172.944 66.0307 162.652 72.4634 152.36 75.0365Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M152.36 73.75C139.494 76.3231 134.348 64.7441 142.067 53.1652C147.213 45.4459 154.933 40.2997 163.939 37.7267C174.231 35.1536 180.664 42.8728 176.804 55.7383C171.658 64.7442 162.652 72.4634 152.36 73.75Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M152.36 72.4634C139.494 75.0365 135.635 63.4576 142.067 51.8787C147.214 44.1594 154.933 39.0132 162.652 36.4401C171.658 33.867 179.377 41.5863 174.231 53.1652C171.658 64.7442 162.652 71.1769 152.36 72.4634Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M152.36 72.4634C140.781 75.0365 135.634 63.4576 142.067 53.1652C147.213 45.4459 154.933 40.2997 162.652 39.0132C171.658 36.4401 178.09 44.1594 174.231 55.7383C170.371 63.4576 162.652 69.8903 152.36 72.4634Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M152.36 71.1769C140.781 73.75 136.921 63.4576 143.354 53.1652C148.5 45.4459 156.219 40.2997 163.939 39.0132C171.658 36.4401 178.091 42.8728 174.231 54.4518C170.371 63.4576 162.652 68.6038 152.36 71.1769Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M153.646 69.8903C142.067 72.4634 138.208 62.171 144.641 53.1652C149.787 45.4459 157.506 41.5863 163.939 39.0132C171.658 36.4401 178.091 42.8728 172.945 54.4518C169.085 62.171 162.652 67.3172 153.646 69.8903Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M153.646 69.8904C143.354 72.4634 138.208 63.4576 144.64 54.4518C149.786 46.7325 157.506 42.8729 163.938 41.5863C171.658 39.0132 176.804 45.4459 172.944 55.7383C169.085 62.1711 162.652 67.3173 153.646 69.8904Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M153.646 68.6038C143.354 72.4634 139.494 62.171 145.927 53.1652C151.073 45.4459 158.792 41.5863 163.939 40.2997C170.371 39.0132 176.804 42.8728 171.658 54.4518C167.798 60.8845 162.652 66.0307 153.646 68.6038Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M153.646 67.3172C143.354 71.1769 139.494 60.8845 145.927 53.1652C151.073 46.7325 158.792 42.8728 163.939 40.2997C170.371 39.0132 175.517 42.8728 170.371 53.1652C167.798 60.8845 162.652 64.7441 153.646 67.3172Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M153.646 67.3173C143.354 71.1769 140.781 62.1711 145.927 54.4518C151.073 48.019 158.793 44.1594 162.652 42.8729C169.085 41.5863 172.945 45.4459 169.085 54.4518C166.512 59.598 161.366 63.4576 153.646 67.3173Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M153.646 66.0307C144.64 69.8904 140.781 60.8845 145.927 54.4518C151.073 48.019 158.792 44.1594 162.652 42.8729C167.798 41.5863 172.944 45.4459 167.798 54.4518C166.512 59.598 161.365 62.1711 153.646 66.0307Z"
            fill="#8CA6B4"
          />
          <path
            d="M154.933 64.7442C145.927 68.6038 143.354 59.598 148.5 53.1652C153.646 46.7325 161.365 42.8728 163.938 41.5863C169.085 40.2998 172.944 42.8728 169.085 51.8787C165.225 58.3114 161.365 62.1711 154.933 64.7442Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M124.056 53.1652C113.763 66.0307 95.7515 60.8845 89.3188 44.1594C85.4591 33.867 86.7457 22.2881 93.1784 10.7092C100.898 -2.15632 120.196 -2.15632 127.915 11.9957C136.921 26.1477 134.348 42.8728 124.056 53.1652Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M124.056 53.1652C113.763 64.7442 95.7515 60.8845 89.3187 44.1594C86.7456 33.867 86.7456 22.2881 94.4649 10.7092C102.184 -2.15631 120.196 -0.869767 127.915 11.9957C135.634 26.1477 133.061 41.5863 124.056 53.1652Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M122.769 51.8787C112.476 63.4576 95.7511 59.598 90.6049 42.8728C86.7453 33.867 88.0319 22.2881 94.4646 10.7091C102.184 -0.869786 120.196 -0.869787 126.628 11.9957C134.348 26.1477 133.061 41.5863 122.769 51.8787Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M122.769 51.8787C112.476 63.4576 95.7512 59.598 90.605 42.8728C88.0319 33.867 89.3185 22.2881 94.4647 11.9957C102.184 0.416773 118.909 0.416773 126.628 13.2822C133.061 26.1477 131.775 40.2998 122.769 51.8787Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M121.482 50.5921C112.476 62.1711 95.7512 58.3114 90.605 42.8728C88.0319 32.5805 89.3184 22.2881 95.7512 11.9957C102.184 0.416773 118.909 0.416773 125.342 13.2823C131.774 26.1477 130.488 40.2998 121.482 50.5921Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M121.482 50.5921C112.476 60.8845 97.0379 57.0249 91.8917 41.5863C89.3186 32.5805 90.6051 22.2881 95.7513 11.9957C102.184 1.70331 117.623 1.70331 125.342 14.5688C131.775 26.1477 129.202 40.2997 121.482 50.5921Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M120.196 49.3056C112.476 60.8845 97.0379 57.0249 91.8917 41.5863C89.3186 32.5805 90.6051 22.2881 95.7513 11.9957C102.184 1.70331 116.336 1.70331 124.055 14.5688C130.488 26.1477 129.202 39.0132 120.196 49.3056Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M120.196 48.019C112.477 59.598 97.0379 55.7383 93.1783 41.5863C90.6052 32.5805 91.8918 21.0015 97.0379 13.2822C102.184 2.98987 116.336 2.98987 124.055 15.8553C129.202 26.1477 127.915 39.0132 120.196 48.019Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M120.196 48.019C112.477 58.3114 98.3246 54.4518 94.4649 41.5863C90.6053 32.5804 91.8918 21.0015 97.038 13.2822C102.184 4.2764 116.336 2.98985 122.769 15.8553C127.915 26.1477 126.629 37.7266 120.196 48.019Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M118.909 46.7325C111.19 57.0249 98.3245 53.1652 93.1783 40.2997C91.8918 31.2939 93.1783 21.0015 97.038 13.2822C103.471 4.27641 116.336 4.27641 121.482 15.8553C126.629 26.1477 125.342 37.7267 118.909 46.7325Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M118.909 46.7325C111.19 57.0249 98.3243 53.1652 94.4646 40.2998C91.8915 31.2939 94.4646 21.0015 98.3243 14.5688C103.47 5.56298 115.049 4.27643 121.482 17.1419C125.342 26.1477 124.055 36.4401 118.909 46.7325Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M117.622 45.4459C111.19 55.7383 98.3243 51.8787 94.4646 40.2997C91.8915 31.2939 94.4646 22.2881 98.3243 14.5688C103.47 5.56294 115.049 5.56294 120.196 17.1419C125.342 26.1477 124.055 36.4401 117.622 45.4459Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M117.623 45.4459C111.19 55.7383 98.3244 51.8787 95.7513 39.0132C93.1782 30.0074 95.7513 21.0015 99.6109 14.5688C103.471 6.84951 113.763 5.56296 120.196 17.1419C124.055 26.1477 122.769 36.4401 117.623 45.4459Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M116.336 44.1594C111.19 54.4518 98.3244 50.5921 95.7513 39.0132C93.1782 30.0074 95.7513 21.0015 99.6109 14.5688C103.471 6.84952 113.763 6.84952 118.909 18.4284C122.769 26.1477 121.482 35.1536 116.336 44.1594Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M116.336 42.8728C109.903 53.1652 99.611 49.3056 97.0379 39.0132C94.4648 30.0074 97.0379 21.0015 100.898 15.8553C104.757 8.13605 113.763 8.13605 118.909 19.715C121.482 26.1477 120.196 35.1535 116.336 42.8728Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M115.049 42.8729C109.903 53.1652 99.6108 49.3056 97.0378 37.7267C95.7512 28.7208 97.0378 21.0015 100.897 14.5688C104.757 8.13606 113.763 6.84952 117.623 18.4284C120.196 26.1477 120.196 33.867 115.049 42.8729Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M115.049 41.5863C109.903 51.8787 99.6107 48.019 97.0376 37.7267C95.7511 28.7208 97.0376 21.0015 99.6107 15.8553C103.47 9.4226 112.476 9.4226 116.336 19.715C118.909 26.1477 118.909 33.867 115.049 41.5863Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M113.763 41.5863C109.903 50.5921 99.6108 46.7325 98.3243 37.7266C97.0378 28.7208 98.3243 21.0015 100.897 15.8553C104.757 10.7091 111.19 9.4226 116.336 19.715C118.909 26.1477 117.623 32.5804 113.763 41.5863Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M113.763 40.2997C109.903 50.5921 100.897 46.7325 98.3243 36.4401C97.0378 28.7208 99.6109 21.0015 102.184 17.1419C104.757 11.9957 111.19 10.7091 115.049 21.0015C117.623 26.1477 116.336 32.5804 113.763 40.2997Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M112.477 40.2997C108.617 49.3056 99.611 46.7325 98.3245 37.7266C98.3245 28.7208 99.611 21.0015 102.184 17.1419C104.757 11.9957 111.19 10.7091 113.763 21.0015C116.336 26.1477 116.336 32.5805 112.477 40.2997Z"
            fill="#8CA6B4"
          />
          <path
            d="M112.476 39.0132C109.903 48.019 100.897 44.1594 99.6107 36.4401C98.3242 27.4343 100.897 21.0015 102.184 17.1419C104.757 11.9957 109.903 11.9957 113.763 21.0015C115.049 26.1477 115.049 31.2939 112.476 39.0132Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M85.4589 73.75C81.5993 90.4751 66.1607 93.0482 52.0087 80.1827C44.2894 73.75 39.1432 62.1711 39.1432 49.3056C40.4297 33.867 52.0087 26.1477 64.8741 35.1536C79.0262 42.8728 89.3185 59.598 85.4589 73.75Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M85.459 73.75C81.5994 89.1886 66.1608 91.7617 53.2953 80.1827C45.576 73.75 40.4298 62.1711 40.4298 49.3056C40.4298 35.1536 52.0088 27.4343 64.8742 35.1536C77.7397 42.8728 88.0321 59.598 85.459 73.75Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M84.1725 73.75C81.5994 87.902 66.1608 91.7617 53.2953 78.8962C45.576 72.4634 40.4299 62.1711 41.7164 49.3056C41.7164 35.1536 52.0088 27.4343 66.1608 36.4401C77.7397 44.1594 86.7456 59.598 84.1725 73.75Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M82.886 72.4635C80.3129 87.902 66.1608 90.4751 53.2954 78.8962C45.5761 72.4635 41.7164 62.1711 41.7164 49.3056C41.7164 35.1536 52.0088 28.7208 64.8743 36.4401C76.4532 44.1594 86.7456 59.598 82.886 72.4635Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M82.886 72.4634C80.3129 86.6155 66.1608 89.1886 53.2954 78.8962C46.8626 71.1769 41.7164 60.8845 41.7164 49.3056C41.7164 36.4401 52.0088 30.0074 64.8743 37.7267C76.4532 45.4459 85.4591 59.598 82.886 72.4634Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M81.5991 72.4634C79.026 86.6155 66.1605 89.1886 53.2951 77.6096C46.8623 71.1769 43.0027 60.8845 43.0027 49.3056C43.0027 37.7267 52.0085 30.0074 64.874 39.0132C75.1664 45.4459 84.1722 58.3114 81.5991 72.4634Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M81.5991 71.1769C79.026 85.3289 64.874 87.902 54.5816 77.6096C46.8623 71.1769 43.0027 60.8845 43.0027 49.3056C43.0027 37.7266 52.0085 31.2939 64.874 39.0132C75.1664 45.4459 82.8857 58.3114 81.5991 71.1769Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M80.3127 71.1769C79.0261 84.0424 64.8741 86.6155 54.5817 76.3231C46.8624 69.8904 43.0028 59.598 44.2893 49.3056C44.2893 37.7267 52.0086 32.5805 64.8741 40.2998C73.8799 46.7325 81.5992 58.3114 80.3127 71.1769Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M79.0261 69.8903C77.7396 84.0424 64.8741 86.6155 54.5817 76.3231C48.149 69.8903 44.2893 59.598 44.2893 50.5921C44.2893 39.0132 52.0086 32.5805 63.5876 40.2997C73.8799 46.7325 80.3127 58.3114 79.0261 69.8903Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M79.0261 69.8903C77.7396 82.7558 64.8741 85.3289 54.5817 75.0365C48.149 68.6038 44.2893 58.3114 44.2893 49.3056C44.2893 39.0132 52.0086 32.5805 63.5876 40.2997C73.8799 48.019 80.3127 58.3114 79.0261 69.8903Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M77.7396 69.8904C77.7396 82.7558 64.8741 84.0424 54.5818 75.0365C48.149 68.6038 45.5759 58.3114 45.5759 50.5921C45.5759 40.2998 53.2952 35.1536 63.5876 42.8729C72.5934 48.019 79.0262 58.3114 77.7396 69.8904Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M77.7396 68.6038C77.7396 81.4693 64.8741 82.7558 55.8683 73.75C49.4356 67.3173 45.5759 58.3114 45.5759 50.5921C45.5759 41.5863 53.2952 35.1536 63.5876 42.8728C72.5934 48.019 77.7396 58.3114 77.7396 68.6038Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M76.4532 68.6038C76.4532 80.1827 64.8743 82.7558 55.8684 73.75C49.4357 67.3173 46.8626 58.3114 46.8626 50.5921C46.8626 41.5863 53.2953 36.4401 63.5877 44.1594C71.307 49.3056 76.4532 58.3114 76.4532 68.6038Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M75.1666 68.6038C75.1666 80.1827 63.5877 82.7558 55.8684 73.75C49.4357 66.0307 46.8626 57.0249 46.8626 50.5921C46.8626 41.5863 53.2953 37.7267 63.5877 44.1594C71.307 49.3056 75.1666 58.3114 75.1666 68.6038Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M75.1667 67.3172C75.1667 78.8962 63.5878 80.1827 55.8685 72.4634C50.7223 66.0307 48.1492 57.0249 48.1492 50.5921C48.1492 42.8728 54.582 37.7267 63.5878 45.4459C70.0205 50.5921 75.1667 58.3114 75.1667 67.3172Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M73.8802 67.3173C73.8802 78.8962 63.5878 80.1827 55.8685 72.4634C50.7223 64.7442 48.1492 57.0249 48.1492 50.5921C48.1492 42.8729 53.2954 39.0132 63.5878 45.4459C70.0205 50.5921 73.8802 58.3114 73.8802 67.3173Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M73.8802 67.3172C75.1667 78.8962 63.5878 80.1827 57.1551 71.1769C50.7223 64.7442 49.4358 55.7383 48.1492 50.5921C48.1492 42.8729 53.2954 39.0132 62.3013 46.7325C68.734 50.5921 72.5936 58.3114 73.8802 67.3172Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M72.5933 66.0307C73.8798 77.6096 63.5875 78.8962 57.1547 71.1769C52.0085 64.7442 49.4354 55.7383 49.4354 50.5921C49.4354 44.1594 54.5816 40.2997 63.5875 46.7325C68.7336 51.8787 71.3067 58.3114 72.5933 66.0307Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M71.3067 66.0307C73.8798 76.3231 63.5874 77.6096 57.1547 69.8903C52.0085 63.4576 49.4354 55.7383 49.4354 50.5921C49.4354 44.1594 53.2951 40.2998 62.3009 48.019C67.4471 51.8787 71.3067 57.0249 71.3067 66.0307Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M71.3068 66.0307C72.5934 76.3231 63.5875 77.6096 58.4414 69.8903C52.0086 63.4576 50.7221 54.4518 50.7221 50.5921C50.7221 45.446 54.5817 41.5863 63.5875 48.019C67.4472 51.8787 70.0203 57.0249 71.3068 66.0307Z"
            fill="#8CA6B4"
          />
          <path
            d="M70.0203 64.7442C72.5934 75.0365 62.301 75.0366 57.1548 68.6038C53.2952 62.1711 50.7221 54.4518 50.7221 50.5921C50.7221 45.4459 54.5817 41.5863 62.301 49.3056C66.1607 53.1652 68.7337 57.0249 70.0203 64.7442Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M46.8626 185.68C30.1375 186.966 23.7047 172.814 31.424 156.089C35.2837 147.083 44.2895 138.077 58.4415 135.504C72.5935 131.645 85.459 140.65 81.5994 156.089C76.4532 171.528 62.3012 185.68 46.8626 185.68Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M46.8628 185.68C31.4242 186.966 23.705 172.814 31.4242 156.089C35.2839 147.083 44.2897 139.364 57.1552 135.504C71.3072 131.645 82.8861 140.65 79.0265 156.089C75.1669 170.241 61.0148 184.393 46.8628 185.68Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M46.8628 184.393C31.4242 185.68 24.9915 172.814 31.4242 156.089C35.2839 147.083 44.2897 139.364 57.1552 135.504C71.3072 131.645 82.8861 140.65 79.0265 156.089C75.1668 170.241 61.0148 183.107 46.8628 184.393Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M46.8629 183.107C31.4243 184.393 24.9915 171.528 32.7108 156.089C36.5705 147.083 45.5763 139.364 57.1552 136.791C70.0207 132.931 81.5996 141.937 77.74 156.089C73.8804 170.241 61.0149 181.82 46.8629 183.107Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M48.1492 183.107C33.9972 184.393 26.2779 171.528 33.9972 157.376C37.8569 148.37 46.8627 140.65 58.4416 138.077C71.3071 134.218 81.5995 141.937 77.7398 157.376C73.8802 168.955 61.0147 180.533 48.1492 183.107Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M48.1495 181.82C33.9974 183.107 27.5647 171.528 33.9974 156.089C37.8571 147.083 46.8629 140.65 57.1553 136.791C68.7342 132.931 80.3132 140.65 75.167 154.802C72.5939 168.955 61.0149 180.533 48.1495 181.82Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M48.1495 180.533C33.9974 183.107 27.5647 170.241 35.284 156.089C39.1436 147.083 48.1495 140.65 58.4418 138.077C70.0208 134.218 80.3132 141.937 76.4535 156.089C72.5939 168.955 61.0149 179.247 48.1495 180.533Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M48.1492 180.533C33.9972 183.107 28.851 170.241 35.2837 157.376C39.1434 148.37 48.1492 141.937 58.4416 139.364C70.0205 136.791 79.0264 143.224 75.1667 157.376C71.3071 167.668 61.0147 177.96 48.1492 180.533Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M48.1494 179.247C35.2839 181.82 28.8512 170.241 35.2839 157.376C39.1436 149.656 48.1494 143.224 57.1552 139.364C67.4476 136.791 76.4534 143.224 72.5938 156.089C70.0207 167.668 59.7283 176.674 48.1494 179.247Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M48.1495 177.96C35.284 180.533 30.1378 168.955 36.5706 156.089C40.4302 148.37 49.436 141.937 58.4419 139.364C68.7342 136.791 77.7401 143.224 73.8804 156.089C70.0208 166.381 59.7284 175.387 48.1495 177.96Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M49.4357 177.96C36.5702 180.533 31.424 168.955 37.8567 157.376C41.7164 149.656 50.7222 143.224 58.4415 140.65C68.7339 138.077 76.4532 143.224 72.5935 156.089C68.7339 166.381 59.7281 175.387 49.4357 177.96Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M49.4359 176.674C37.857 179.247 31.4243 168.954 37.857 157.376C41.7167 149.656 50.7225 143.224 58.4418 141.937C67.4476 139.364 75.1669 144.51 71.3072 157.376C68.7341 166.381 59.7283 174.101 49.4359 176.674Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M49.4357 175.387C37.8568 177.96 32.7106 167.668 39.1433 157.376C43.003 149.656 52.0088 144.51 58.4415 141.937C67.4474 139.364 75.1667 144.51 71.307 156.089C67.4474 165.095 59.7281 172.814 49.4357 175.387Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M49.4357 174.101C37.8568 177.96 32.7106 167.668 39.1433 157.376C44.2895 149.656 52.0088 144.51 58.4415 141.937C66.1608 139.364 73.8801 144.51 70.0205 156.089C66.1608 165.095 59.7281 171.528 49.4357 174.101Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M49.436 174.101C39.1436 177.96 33.9974 167.668 39.1436 157.376C44.2898 149.656 52.0091 144.51 58.4418 143.224C66.1611 140.65 72.5938 145.797 68.7342 157.376C66.1611 165.095 58.4418 170.241 49.436 174.101Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M49.4357 172.814C39.1433 176.674 33.9971 166.381 40.4299 157.376C45.5761 149.656 53.2953 144.51 58.4415 143.224C66.1608 140.65 72.5936 145.797 67.4474 156.089C64.8743 163.808 58.4415 170.241 49.4357 172.814Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M50.7225 171.528C40.4301 175.387 36.5704 165.095 41.7166 157.376C46.8628 149.656 53.2955 145.797 59.7283 143.224C66.161 140.65 72.5938 144.51 68.7341 156.089C64.8745 163.808 58.4417 168.955 50.7225 171.528Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M50.7224 171.528C40.4301 175.387 36.5704 166.381 41.7166 157.376C46.8628 149.656 53.2955 145.797 58.4417 144.51C64.8745 141.937 70.0207 145.797 66.161 156.089C63.5879 162.522 58.4417 167.668 50.7224 171.528Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M50.7226 170.241C41.7168 174.101 36.5706 165.095 43.0033 157.376C48.1495 149.656 54.5822 145.797 59.7284 144.51C64.8746 141.937 71.3073 145.797 66.1612 156.089C63.5881 162.522 58.4419 166.381 50.7226 170.241Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M50.7222 168.955C41.7164 174.101 37.8568 165.095 43.0029 157.376C48.1491 150.943 54.5819 147.083 58.4415 144.51C63.5877 141.937 68.7339 145.797 64.8743 156.089C62.3012 162.522 58.4415 166.381 50.7222 168.955Z"
            fill="#8CA6B4"
          />
          <path
            d="M50.7222 168.955C41.7164 174.101 37.8568 165.095 43.0029 158.662C48.1491 152.229 54.5819 148.37 58.4415 147.083C63.5877 145.797 67.4474 148.37 63.5877 157.376C61.0146 161.235 58.4415 165.095 50.7222 168.955Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M10.8393 126.498C-3.31277 118.779 -2.02622 103.341 13.4124 93.0482C21.1316 87.902 33.9971 85.3289 46.8626 89.1886C61.0146 93.0482 66.1608 105.914 54.5819 117.493C43.0029 127.785 24.9913 134.218 10.8393 126.498Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M12.1259 126.498C-2.02612 118.779 -0.739569 103.341 14.699 93.0482C22.4183 87.902 35.2838 85.3289 48.1492 89.1886C61.0147 94.3347 64.8744 105.914 53.2954 117.493C43.003 127.785 24.9914 132.931 12.1259 126.498Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M12.1258 125.212C-0.739672 118.779 0.546876 103.341 14.6989 94.3348C22.4182 87.902 33.9971 86.6155 46.8626 90.4751C59.7281 94.3348 64.8743 105.914 53.2953 116.206C43.0029 126.498 24.9913 131.645 12.1258 125.212Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M13.4122 125.212C-0.739794 118.779 0.546754 103.341 14.6988 94.3347C23.7046 89.1886 35.2835 86.6155 46.8625 90.4751C59.7279 94.3347 63.5876 105.914 53.2952 116.206C41.7163 126.498 26.2777 131.645 13.4122 125.212Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M13.4125 123.925C0.54698 118.779 1.83353 103.341 15.9856 94.3348C23.7048 89.1886 35.2838 87.902 46.8627 90.4751C58.4416 94.3348 63.5878 105.914 52.0089 116.206C41.7165 125.212 26.2779 130.358 13.4125 123.925Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M14.6988 123.925C1.83335 117.493 3.1199 103.341 15.9854 95.6213C23.7047 90.4751 35.2836 89.1886 45.576 91.7617C58.4414 95.6213 62.3011 105.914 50.7222 116.206C41.7163 125.212 26.2778 129.072 14.6988 123.925Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M14.699 122.639C1.83357 117.493 3.12012 103.341 17.2721 95.6213C24.9914 90.4751 35.2838 89.1886 45.5762 91.7617C57.1551 95.6213 61.0148 105.914 50.7224 114.92C41.7165 123.925 26.278 127.785 14.699 122.639Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M15.9855 122.639C3.12001 117.493 4.40655 103.341 17.272 95.6213C24.9913 90.4751 35.2837 90.4751 45.5761 93.0482C57.155 95.6213 59.7281 105.914 49.4357 114.92C40.4299 122.639 27.5644 127.785 15.9855 122.639Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M15.9855 121.352C3.12001 116.206 4.40655 103.341 17.272 95.6213C26.2779 91.7617 36.5702 90.4751 45.5761 93.0482C55.8685 95.6213 59.7281 105.914 49.4357 114.92C40.4299 122.639 27.5644 126.498 15.9855 121.352Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M17.2721 121.352C4.4066 116.206 5.69314 103.341 18.5586 96.9078C26.2779 91.7617 36.5703 91.7617 45.5761 94.3347C55.8685 96.9078 59.7281 105.914 49.4358 114.92C40.4299 121.352 27.5645 125.212 17.2721 121.352Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M17.2722 120.066C5.69324 116.206 6.97979 103.341 18.5587 96.9078C26.278 93.0482 36.5704 91.7617 45.5762 94.3348C55.8686 96.9079 58.4417 105.914 48.1493 113.633C40.43 121.352 28.8511 123.925 17.2722 120.066Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M18.5586 120.066C6.97966 116.206 8.2662 103.341 18.5586 98.1944C26.2779 94.3348 36.5703 93.0482 44.2895 95.6213C53.2954 98.1944 57.155 105.914 46.8626 114.92C39.1433 120.066 28.851 123.925 18.5586 120.066Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M18.5584 118.779C6.97946 116.206 8.26601 103.341 19.8449 98.1944C27.5642 94.3348 37.8566 93.0482 44.2893 95.6213C53.2952 98.1944 55.8683 105.914 46.8624 113.633C39.1432 120.066 28.8508 122.639 18.5584 118.779Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M19.8452 118.779C8.26631 116.206 9.55286 103.341 19.8452 98.1944C27.5645 94.3347 36.5704 94.3348 44.2896 95.6213C52.0089 98.1944 55.8686 105.914 45.5762 113.633C39.1435 118.779 28.8511 121.352 19.8452 118.779Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M19.8452 117.493C8.26631 114.92 9.55286 103.341 19.8452 98.1944C27.5645 94.3347 36.5704 94.3348 43.0031 95.6213C52.0089 98.1944 54.582 105.914 45.5762 112.346C39.1435 118.779 30.1376 120.066 19.8452 117.493Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M21.1315 117.493C9.55253 114.92 10.8391 104.627 21.1315 99.4809C28.8507 95.6213 37.8566 95.6213 44.2893 96.9078C52.0086 98.1944 54.5817 105.914 45.5759 112.346C37.8566 117.493 30.1373 120.066 21.1315 117.493Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M21.1318 117.493C10.8394 114.92 12.126 104.627 21.1318 100.767C28.8511 96.9078 37.8569 96.9078 43.0031 98.1944C49.4358 99.4809 52.0089 105.914 43.0031 113.633C37.8569 117.493 30.1376 118.779 21.1318 117.493Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M22.418 116.206C12.1256 114.92 13.4121 104.627 22.418 99.4809C30.1373 95.6213 39.1431 95.6213 44.2893 96.9078C50.722 98.1944 53.2951 104.627 44.2893 111.06C37.8566 116.206 31.4238 117.493 22.418 116.206Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M22.418 116.206C12.1256 113.633 13.4121 104.627 22.418 100.767C30.1373 96.9078 39.1431 96.9078 43.0027 98.1944C49.4355 99.4809 52.0086 104.627 43.0027 111.06C37.8566 114.92 31.4238 116.206 22.418 116.206Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M23.7047 114.92C13.4123 113.633 14.6989 104.627 22.4182 100.767C31.424 96.9079 39.1433 98.1944 43.0029 98.1944C48.1491 99.4809 50.7222 104.627 41.7164 111.06C36.5702 114.92 31.424 116.206 23.7047 114.92Z"
            fill="#8CA6B4"
          />
          <path
            d="M23.7046 114.92C13.4123 114.92 14.6988 104.627 23.7046 102.054C31.4239 98.1944 39.1432 98.1944 43.0028 99.4809C48.149 100.767 50.7221 105.914 41.7163 111.06C36.5701 113.633 31.4239 114.92 23.7046 114.92Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M130.488 158.662C127.915 143.224 140.781 134.218 158.792 139.364C167.798 141.937 178.09 150.943 181.95 163.808C187.096 177.96 180.664 189.539 163.938 186.966C149.786 185.68 133.061 174.101 130.488 158.662Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M131.775 158.662C129.202 143.224 142.067 134.218 158.792 140.65C167.798 143.224 176.804 152.229 181.95 163.808C187.096 177.96 180.664 188.253 165.225 185.68C149.787 184.393 134.348 174.101 131.775 158.662Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M131.775 158.662C129.202 143.224 142.067 134.218 158.792 140.65C167.798 143.224 176.804 152.229 180.664 163.808C185.81 176.674 179.377 186.966 163.939 185.68C149.787 183.107 135.634 172.814 131.775 158.662Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M133.061 158.662C130.488 143.224 142.067 135.504 158.792 140.65C167.798 143.224 176.804 150.943 180.664 163.808C185.81 176.674 179.377 186.966 163.938 184.393C149.786 183.107 135.634 172.814 133.061 158.662Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M134.348 158.662C130.488 144.51 143.354 135.504 158.792 140.65C167.798 143.224 175.517 150.943 180.663 162.522C184.523 175.387 179.377 184.393 165.225 181.82C151.073 181.82 136.921 172.814 134.348 158.662Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M134.348 158.662C130.488 144.51 143.354 136.791 158.792 141.937C167.798 145.797 175.517 152.229 179.377 163.808C183.237 175.387 178.09 184.393 163.938 183.107C151.073 180.533 138.207 171.528 134.348 158.662Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M135.634 158.662C131.775 144.51 144.64 136.791 158.792 141.937C167.798 145.797 175.517 152.229 179.377 163.808C183.237 175.387 179.377 184.393 163.938 181.82C151.073 180.533 138.207 171.528 135.634 158.662Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M135.634 158.662C131.775 145.797 143.353 136.791 157.505 141.937C166.511 145.797 172.944 152.229 176.804 162.522C180.663 172.814 176.804 181.82 162.652 179.247C151.073 179.247 139.494 171.528 135.634 158.662Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M136.921 159.949C133.061 147.083 144.64 139.364 158.792 144.51C167.798 148.37 174.231 154.802 178.09 165.095C181.95 175.387 178.09 183.107 163.938 181.82C152.359 179.247 139.494 170.241 136.921 159.949Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M136.921 159.949C133.061 147.083 144.64 139.364 157.506 144.51C166.512 148.37 172.944 154.802 175.517 163.808C179.377 174.101 175.517 181.82 162.652 179.247C152.36 177.96 140.781 170.241 136.921 159.949Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M138.208 159.949C134.348 148.37 145.927 139.364 157.506 144.51C166.512 148.37 172.944 154.802 175.518 163.808C178.091 172.814 175.518 180.533 162.652 177.96C152.36 176.674 142.067 170.241 138.208 159.949Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M139.494 159.949C135.634 148.37 145.927 140.65 158.792 145.797C167.798 149.656 172.944 156.089 175.517 165.095C178.09 174.101 175.517 180.533 162.652 179.247C152.359 176.674 142.067 170.241 139.494 159.949Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M139.494 159.949C135.634 148.37 145.927 140.65 157.506 145.797C165.225 149.656 171.658 156.089 174.231 163.808C176.804 172.814 175.517 179.247 162.652 176.674C153.646 175.387 143.354 168.955 139.494 159.949Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M140.781 159.949C135.635 148.37 147.213 140.65 157.506 145.797C165.225 149.656 171.658 156.089 174.231 163.808C176.804 171.528 175.518 177.96 162.652 176.674C153.646 174.101 144.64 168.955 140.781 159.949Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M140.781 159.949C135.634 149.656 145.927 141.937 157.506 147.083C165.225 150.943 170.371 157.376 172.944 165.095C175.517 172.814 174.231 177.96 162.652 176.674C153.646 174.101 144.64 168.954 140.781 159.949Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M142.067 159.949C136.921 149.656 147.213 141.937 157.506 147.083C165.225 150.943 170.371 157.376 172.944 163.808C175.517 171.528 174.231 176.674 162.652 174.101C153.646 172.814 145.927 167.668 142.067 159.949Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M142.067 159.949C136.921 149.656 147.213 143.224 156.219 147.083C163.938 150.943 169.084 157.376 170.371 163.808C171.658 170.241 171.658 175.387 160.079 174.101C154.932 171.528 147.213 167.668 142.067 159.949Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M143.354 159.949C138.207 150.943 148.5 143.224 156.219 148.37C163.938 152.229 169.085 157.376 170.371 163.808C171.658 170.241 171.658 174.101 161.365 172.814C154.933 171.528 147.213 167.668 143.354 159.949Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M144.64 159.949C139.494 150.943 148.5 143.224 157.506 148.37C165.225 152.229 169.085 157.376 170.371 163.808C171.658 170.241 171.658 174.101 161.365 171.528C154.933 170.241 148.5 166.381 144.64 159.949Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M144.64 159.949C139.494 150.943 148.5 144.51 156.219 148.37C163.938 152.229 167.798 157.376 169.084 163.808C170.371 168.955 171.657 172.814 160.079 171.528C154.932 170.241 149.786 166.381 144.64 159.949Z"
            fill="#8CA6B4"
          />
          <path
            d="M145.927 159.949C140.781 152.229 149.786 144.51 156.219 149.656C163.939 153.516 167.798 158.662 167.798 163.808C169.085 168.955 170.371 171.528 160.079 170.241C154.933 168.955 149.786 166.381 145.927 159.949Z"
            fill="#86A2B0"
          />
          <path
            opacity="0.047619"
            d="M120.196 156.089C108.617 144.51 94.4647 149.656 88.032 167.668C85.4589 176.674 86.7454 189.539 94.4647 201.118C102.184 213.984 116.336 213.984 124.055 199.832C130.488 186.966 131.775 167.668 120.196 156.089Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M120.196 157.376C108.617 145.797 94.4648 150.943 89.3186 168.955C86.7456 177.96 88.0321 190.826 94.4648 201.118C102.184 212.697 115.05 213.984 122.769 199.832C130.488 186.966 130.488 167.668 120.196 157.376Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M120.196 157.376C109.903 145.797 95.7514 150.943 89.3186 167.668C86.7456 176.674 88.0321 188.253 94.4648 199.832C102.184 211.411 113.763 212.697 121.482 198.545C129.202 186.966 129.202 167.668 120.196 157.376Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M118.909 158.662C108.617 147.083 94.4648 152.229 89.3186 168.955C86.7456 177.96 88.0321 189.539 94.4648 199.832C102.184 211.411 113.763 212.697 120.196 198.545C127.915 185.68 129.202 168.955 118.909 158.662Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M118.909 158.662C108.617 147.083 94.4649 152.229 90.6053 168.955C88.0322 177.96 89.3188 189.539 95.7515 199.832C103.471 210.124 113.763 211.411 121.482 198.545C127.915 185.68 127.915 168.955 118.909 158.662Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M118.909 159.949C109.904 148.37 95.7515 153.516 90.6053 168.955C88.0322 177.96 89.3188 188.253 95.7515 198.545C103.471 208.837 113.763 210.124 120.196 197.259C126.629 185.68 126.629 170.241 118.909 159.949Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M117.623 159.949C108.617 149.656 94.4649 153.516 90.6053 168.955C88.0322 177.96 89.3188 188.253 95.7515 197.259C102.184 207.551 112.477 208.837 118.909 195.972C125.342 185.68 126.629 170.241 117.623 159.949Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M117.622 161.235C108.617 150.943 95.7511 154.802 91.8915 170.241C89.3184 179.247 90.6049 189.539 97.0377 198.545C103.47 207.551 112.476 210.124 118.909 197.259C125.342 185.68 125.342 170.241 117.622 161.235Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M117.622 161.235C109.903 150.943 95.7511 154.802 91.8915 168.955C89.3184 177.96 90.6049 188.253 97.0377 195.972C103.47 206.264 112.476 207.551 118.909 194.685C124.055 185.68 125.342 171.528 117.622 161.235Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M117.623 162.522C109.903 152.229 97.038 156.089 93.1783 170.241C90.6052 179.247 93.1783 188.253 98.3245 197.259C103.471 204.978 112.477 206.264 118.909 194.685C124.055 184.393 124.055 171.528 117.623 162.522Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M116.336 162.522C108.617 152.229 95.7514 156.089 93.1783 170.241C90.6052 179.247 93.1783 188.253 98.3245 195.972C104.757 203.691 111.19 206.264 117.623 194.685C122.769 184.393 122.769 171.528 116.336 162.522Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M116.336 163.808C109.903 153.516 97.038 157.376 93.1783 170.241C90.6052 179.247 93.1783 188.253 98.3245 194.685C103.471 202.405 111.19 204.978 116.336 193.399C121.482 184.393 122.769 172.814 116.336 163.808Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M116.336 163.808C109.903 153.516 97.038 157.376 94.4649 170.241C93.1784 179.247 94.4649 186.966 99.6111 194.685C104.757 202.405 111.19 203.691 117.623 192.112C121.482 184.393 121.482 172.814 116.336 163.808Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M115.05 165.095C108.617 154.802 95.7515 158.662 94.4649 170.241C93.1784 179.247 94.4649 186.966 99.6111 193.399C104.757 199.832 109.903 202.405 116.336 190.826C120.196 184.393 120.196 172.814 115.05 165.095Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M115.05 165.095C108.617 154.802 97.038 158.662 94.4649 170.241C93.1784 179.247 94.4649 186.966 99.6111 193.399C104.757 199.832 109.903 202.405 115.05 190.826C118.909 184.393 120.196 174.101 115.05 165.095Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M115.049 166.381C109.903 156.089 97.0377 159.949 95.7511 171.528C94.4646 180.533 95.7511 188.253 100.897 193.399C106.043 199.832 109.903 201.118 115.049 190.826C118.909 183.107 118.909 174.101 115.049 166.381Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M113.763 166.381C108.617 156.089 97.0377 159.949 95.7511 170.241C94.4646 179.247 95.7511 185.68 100.897 192.112C104.757 197.259 109.903 199.832 115.049 189.539C117.622 183.107 118.909 174.101 113.763 166.381Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M113.763 167.668C108.617 157.376 97.0377 161.235 95.7511 171.528C94.4646 180.533 95.7511 186.966 100.897 192.112C104.757 197.259 108.617 199.832 113.763 189.539C116.336 183.107 117.622 175.387 113.763 167.668Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M113.763 167.668C109.903 158.662 98.3245 161.235 97.0379 171.528C95.7514 180.533 98.3245 186.966 102.184 190.826C106.044 195.972 108.617 198.545 113.763 188.253C116.336 183.107 116.336 175.387 113.763 167.668Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M112.477 168.955C108.617 159.949 97.0379 162.522 97.0379 171.528C95.7514 180.533 98.3245 186.966 102.184 190.826C106.044 194.685 108.617 197.259 112.477 188.253C115.05 183.107 116.336 175.387 112.477 168.955Z"
            fill="#8CA6B4"
          />
          <path
            d="M112.477 168.955C108.617 159.949 98.3245 162.522 97.0379 171.528C95.7514 180.533 98.3245 185.68 102.184 189.539C106.044 193.399 107.33 195.972 112.477 186.966C113.763 181.82 115.05 176.674 112.477 168.955Z"
            fill="#86A2B0"
          />
        </g>
        <path
          d="M112.476 27.4343C112.476 39.0132 100.897 49.3056 100.897 49.3056C100.897 49.3056 90.6051 39.0132 90.6051 27.4343C90.6051 15.8554 102.184 5.56297 102.184 5.56297C102.184 5.56297 112.476 15.8554 112.476 27.4343Z"
          fill="#FFE3AB"
        />
        <path
          d="M112.476 176.674C112.476 188.253 100.897 198.545 100.897 198.545C100.897 198.545 90.6051 188.253 90.6051 176.674C90.6051 165.095 102.184 154.803 102.184 154.803C102.184 154.803 112.476 165.095 112.476 176.674Z"
          fill="#FFE3AB"
        />
        <path
          d="M27.5642 91.7617C39.1431 91.7617 49.4355 103.341 49.4355 103.341C49.4355 103.341 39.1431 113.633 27.5642 113.633C15.9853 113.633 5.69287 102.054 5.69287 102.054C5.69287 102.054 15.9853 91.7617 27.5642 91.7617Z"
          fill="#FFE3AB"
        />
        <path
          d="M176.804 91.7617C188.383 91.7617 198.675 103.341 198.675 103.341C198.675 103.341 189.669 114.92 176.804 114.92C165.225 114.92 154.932 103.341 154.932 103.341C154.932 103.341 165.225 91.7617 176.804 91.7617Z"
          fill="#FFE3AB"
        />
        <path
          d="M41.7163 147.083C49.4356 139.364 64.8742 139.364 64.8742 139.364C64.8742 139.364 64.8742 154.803 57.1549 162.522C48.149 171.528 33.997 170.241 33.997 170.241C33.997 170.241 32.7105 156.089 41.7163 147.083Z"
          fill="#FFE3AB"
        />
        <path
          d="M147.213 41.5863C156.219 32.5805 170.371 33.867 170.371 33.867C170.371 33.867 171.657 48.019 162.652 57.0249C154.932 64.7442 139.494 64.7442 139.494 64.7442C139.494 64.7442 139.494 49.3056 147.213 41.5863Z"
          fill="#FFE3AB"
        />
        <path
          d="M147.213 162.522C138.207 153.516 139.494 139.364 139.494 139.364C139.494 139.364 153.646 138.077 162.652 147.083C171.657 156.089 170.371 170.241 170.371 170.241C170.371 170.241 156.219 171.528 147.213 162.522Z"
          fill="#FFE3AB"
        />
        <path
          d="M41.7163 57.0249C32.7105 48.019 33.997 33.867 33.997 33.867C33.997 33.867 48.149 32.5805 57.1549 41.5863C64.8741 49.3056 64.8741 64.7442 64.8741 64.7442C64.8741 64.7442 49.4356 64.7442 41.7163 57.0249Z"
          fill="#FFE3AB"
        />
        <path
          d="M167.798 139.364C158.793 135.504 154.933 125.212 154.933 125.212C154.933 125.212 165.225 120.066 174.231 123.925C183.237 127.785 187.097 138.077 187.097 138.077C187.097 138.077 176.804 141.937 167.798 139.364Z"
          fill="#FFE3AB"
        />
        <path
          d="M30.1376 81.4693C21.1317 77.6096 17.2721 67.3172 17.2721 67.3172C17.2721 67.3172 27.5645 62.1711 36.5703 64.7441C45.5761 68.6038 49.4358 78.8962 49.4358 78.8962C49.4358 78.8962 37.8569 85.3289 30.1376 81.4693Z"
          fill="#FFE3AB"
        />
        <path
          d="M81.5996 30.0074C85.4593 39.0132 80.3131 49.3056 80.3131 49.3056C80.3131 49.3056 68.7342 45.4459 64.8745 36.4401C62.3014 27.4343 67.4476 17.1419 67.4476 17.1419C67.4476 17.1419 77.74 21.0015 81.5996 30.0074Z"
          fill="#FFE3AB"
        />
        <path
          d="M139.494 167.668C143.354 176.674 138.207 186.966 138.207 186.966C138.207 186.966 126.628 183.107 124.055 174.101C120.196 165.095 125.342 154.802 125.342 154.802C125.342 154.802 135.634 158.662 139.494 167.668Z"
          fill="#FFE3AB"
        />
        <path
          d="M30.1376 122.639C39.1434 118.779 49.4358 123.925 49.4358 123.925C49.4358 123.925 45.5762 135.504 36.5703 138.077C27.5645 141.937 17.2721 136.791 17.2721 136.791C17.2721 136.791 21.1318 126.498 30.1376 122.639Z"
          fill="#FFE3AB"
        />
        <path
          d="M167.798 64.7442C176.804 60.8845 187.097 66.0307 187.097 66.0307C187.097 66.0307 183.237 77.6096 174.231 80.1827C166.512 85.3289 154.933 80.1827 154.933 80.1827C154.933 80.1827 158.793 68.6038 167.798 64.7442Z"
          fill="#FFE3AB"
        />
        <path
          d="M64.8744 167.668C68.7341 158.662 79.0265 154.802 79.0265 154.802C79.0265 154.802 84.1726 165.095 80.313 174.101C76.4534 183.107 66.161 186.966 66.161 186.966C66.161 186.966 62.3013 176.674 64.8744 167.668Z"
          fill="#FFE3AB"
        />
        <path
          d="M122.769 30.0074C126.629 21.0015 136.921 17.1419 136.921 17.1419C136.921 17.1419 142.067 27.4343 138.208 36.4401C134.348 45.4459 124.056 49.3056 124.056 49.3056C124.056 49.3056 118.909 37.7267 122.769 30.0074Z"
          fill="#FFE3AB"
        />
        <path
          d="M113.763 28.7208C113.763 40.2998 103.471 49.3056 103.471 49.3056C103.471 49.3056 91.8918 40.2998 91.8918 28.7208C91.8918 15.8554 103.471 6.84952 103.471 6.84952C103.471 6.84952 113.763 15.8554 113.763 28.7208Z"
          fill="url(#paint0_linear_2_192)"
        />
        <path
          d="M113.763 177.96C113.763 189.539 102.184 199.832 102.184 199.832C102.184 199.832 90.6051 190.826 90.6051 177.96C90.6051 166.381 102.184 156.089 102.184 156.089C102.184 156.089 113.763 166.381 113.763 177.96Z"
          fill="url(#paint1_linear_2_192)"
        />
        <path
          d="M28.8508 91.7617C40.4298 91.7617 49.4356 103.341 49.4356 103.341C49.4356 103.341 40.4298 113.633 28.8508 113.633C15.9854 113.633 6.97952 103.341 6.97952 103.341C6.97952 103.341 15.9854 91.7617 28.8508 91.7617Z"
          fill="url(#paint2_linear_2_192)"
        />
        <path
          d="M178.09 91.7617C189.669 91.7617 199.962 103.341 199.962 103.341C199.962 103.341 190.956 114.92 178.09 114.92C166.511 114.92 156.219 103.341 156.219 103.341C156.219 103.341 166.511 91.7617 178.09 91.7617Z"
          fill="url(#paint3_linear_2_192)"
        />
        <path
          d="M43.0029 148.37C50.7222 139.364 64.8742 140.65 64.8742 140.65C64.8742 140.65 66.1608 154.803 57.155 163.808C48.1491 172.814 33.9971 171.528 33.9971 171.528C33.9971 171.528 33.9971 156.089 43.0029 148.37Z"
          fill="url(#paint4_linear_2_192)"
        />
        <path
          d="M148.5 42.8729C157.505 33.867 171.657 35.1536 171.657 35.1536C171.657 35.1536 172.944 49.3056 163.938 58.3114C154.932 66.0307 140.78 64.7442 140.78 64.7442C140.78 64.7442 139.494 50.5921 148.5 42.8729Z"
          fill="url(#paint5_linear_2_192)"
        />
        <path
          d="M148.5 163.808C139.494 154.803 140.78 140.65 140.78 140.65C140.78 140.65 154.932 139.364 163.938 148.37C172.944 157.376 171.657 171.528 171.657 171.528C171.657 171.528 156.219 172.814 148.5 163.808Z"
          fill="url(#paint6_linear_2_192)"
        />
        <path
          d="M43.0029 58.3114C33.9971 49.3056 35.2837 35.1536 35.2837 35.1536C35.2837 35.1536 49.4357 33.867 58.4415 42.8729C66.1608 50.5921 64.8743 64.7442 64.8743 64.7442C64.8743 64.7442 50.7222 66.0307 43.0029 58.3114Z"
          fill="url(#paint7_linear_2_192)"
        />
        <path
          d="M169.085 139.364C160.079 135.504 156.219 125.212 156.219 125.212C156.219 125.212 166.511 120.066 175.517 123.925C184.523 127.785 188.383 138.077 188.383 138.077C188.383 138.077 178.09 143.224 169.085 139.364Z"
          fill="url(#paint8_linear_2_192)"
        />
        <path
          d="M30.1376 82.7558C21.1318 78.8962 17.2721 68.6038 17.2721 68.6038C17.2721 68.6038 27.5645 63.4576 36.5703 67.3172C45.5762 71.1769 49.4358 81.4693 49.4358 81.4693C49.4358 81.4693 39.1434 86.6155 30.1376 82.7558Z"
          fill="url(#paint9_linear_2_192)"
        />
        <path
          d="M82.8861 30.0074C86.7457 39.0132 81.5996 49.3056 81.5996 49.3056C81.5996 49.3056 70.0206 45.4459 67.4475 36.4401C62.3013 28.7208 67.4475 18.4284 67.4475 18.4284C67.4475 18.4284 79.0265 22.2881 82.8861 30.0074Z"
          fill="url(#paint10_linear_2_192)"
        />
        <path
          d="M139.494 168.955C143.354 177.96 138.207 188.253 138.207 188.253C138.207 188.253 126.628 184.393 124.055 175.387C120.196 166.381 125.342 156.089 125.342 156.089C125.342 156.089 136.921 159.949 139.494 168.955Z"
          fill="url(#paint11_linear_2_192)"
        />
        <path
          d="M30.1376 123.925C39.1434 120.066 49.4358 125.212 49.4358 125.212C49.4358 125.212 45.5762 136.791 36.5703 139.364C27.5645 143.224 17.2721 138.077 17.2721 138.077C17.2721 138.077 22.4183 127.785 30.1376 123.925Z"
          fill="url(#paint12_linear_2_192)"
        />
        <path
          d="M169.085 66.0307C178.09 62.1711 188.383 67.3172 188.383 67.3172C188.383 67.3172 184.523 78.8962 175.517 81.4693C166.511 85.3289 156.219 80.1827 156.219 80.1827C156.219 80.1827 160.079 69.8903 169.085 66.0307Z"
          fill="url(#paint13_linear_2_192)"
        />
        <path
          d="M66.1607 168.955C70.0204 159.949 80.3127 156.089 80.3127 156.089C80.3127 156.089 85.4589 166.381 81.5993 175.387C77.7396 184.393 67.4473 188.253 67.4473 188.253C67.4473 188.253 62.3011 177.96 66.1607 168.955Z"
          fill="url(#paint14_linear_2_192)"
        />
        <path
          d="M124.055 30.0074C127.915 21.0015 138.207 17.1419 138.207 17.1419C138.207 17.1419 143.354 27.4343 139.494 36.4401C135.634 45.4459 125.342 49.3056 125.342 49.3056C125.342 49.3056 120.196 39.0132 124.055 30.0074Z"
          fill="url(#paint15_linear_2_192)"
        />
        <g style={{ 'mix-blend-mode': 'multiply' }}>
          <path
            opacity="0.047619"
            d="M170.371 177.96C140.781 203.691 99.6113 208.837 62.3014 186.966C13.4126 157.376 23.705 116.206 45.5763 114.919C67.4476 113.633 86.7458 122.639 102.184 105.914C118.909 87.902 118.909 68.6038 122.769 49.3056C127.915 26.1477 156.219 19.715 185.81 51.8787C217.974 86.6155 208.968 145.797 170.371 177.96Z"
            fill="#F9FBFB"
          />
          <path
            opacity="0.095238"
            d="M169.085 176.674C140.781 201.118 100.898 206.264 64.8743 185.68C15.9854 157.376 26.2778 117.493 46.8626 116.206C68.7339 114.919 88.0321 123.925 103.471 107.2C120.196 89.1885 120.196 69.8903 124.055 50.5921C127.915 28.7208 154.933 22.2881 184.523 54.4518C215.4 87.902 206.395 144.51 169.085 176.674Z"
            fill="#F3F6F7"
          />
          <path
            opacity="0.1429"
            d="M169.085 174.101C140.781 198.545 102.184 203.691 67.4476 184.393C21.1319 157.376 28.8511 118.779 49.4359 117.493C68.7341 116.206 89.3189 125.212 106.044 108.487C122.769 89.1885 121.483 71.1769 125.342 51.8787C129.202 31.2939 154.933 24.8612 183.237 55.7383C212.827 87.902 205.108 143.224 169.085 174.101Z"
            fill="#EEF2F4"
          />
          <path
            opacity="0.1905"
            d="M167.798 172.814C140.781 195.972 103.471 202.405 68.7339 183.107C22.4182 157.376 28.8509 120.066 49.4357 118.779C68.7339 117.493 90.6052 127.785 107.33 108.487C124.055 90.4751 122.769 72.4634 126.629 53.1652C130.488 32.5805 154.933 26.1477 181.95 57.0249C210.254 87.902 202.535 141.937 167.798 172.814Z"
            fill="#E8EDF0"
          />
          <path
            opacity="0.2381"
            d="M166.512 170.241C139.494 193.399 104.758 199.832 71.3073 181.82C26.2781 158.662 31.4243 121.352 50.7225 120.066C70.0207 118.779 90.6055 129.072 108.617 109.773C125.342 91.7617 124.056 73.75 127.915 54.4518C130.488 35.1536 156.219 28.7208 181.95 58.3114C207.681 89.1886 201.249 140.65 166.512 170.241Z"
            fill="#E2E9EC"
          />
          <path
            opacity="0.2857"
            d="M165.225 168.955C139.494 192.112 104.757 197.259 72.5936 180.533C28.851 158.662 33.9972 123.925 52.0088 121.352C70.0205 120.066 91.8918 131.645 109.903 111.06C126.629 91.7617 125.342 75.0365 127.915 55.7383C130.488 36.4401 154.933 31.2939 179.377 59.598C205.108 89.1886 198.675 139.364 165.225 168.955Z"
            fill="#DCE4E8"
          />
          <path
            opacity="0.3333"
            d="M165.225 166.381C140.781 188.253 107.33 194.685 76.4533 179.247C33.9972 158.662 36.5703 125.212 54.582 122.639C71.3071 121.352 94.465 132.931 112.477 112.346C127.915 93.0482 126.629 76.3231 129.202 58.3114C131.775 39.0132 154.933 33.867 178.091 62.1711C202.535 90.4751 197.389 138.077 165.225 166.381Z"
            fill="#D7E0E5"
          />
          <path
            opacity="0.381"
            d="M163.938 165.095C139.494 186.966 108.617 192.112 77.7397 179.247C35.2836 159.949 37.8567 127.785 54.5818 125.212C70.0204 123.925 93.1783 136.791 112.476 113.633C129.202 94.3347 127.915 77.6096 130.488 59.598C133.061 41.5863 154.933 36.4401 176.804 63.4576C199.962 90.4751 194.816 136.791 163.938 165.095Z"
            fill="#D1DCE1"
          />
          <path
            opacity="0.4286"
            d="M162.652 162.522C139.494 183.107 108.617 189.539 79.0262 176.674C39.1432 158.662 39.1432 127.785 55.8684 125.212C71.3069 123.925 94.4648 136.791 115.05 113.633C131.775 94.3348 130.488 77.6096 131.775 59.598C133.061 42.8728 154.933 39.0132 175.517 64.7442C197.389 90.4751 193.529 135.504 162.652 162.522Z"
            fill="#CBD7DD"
          />
          <path
            opacity="0.4762"
            d="M161.365 161.235C139.494 181.82 109.903 188.253 81.5994 176.674C41.7164 159.949 41.7164 129.072 57.155 127.785C71.307 126.498 95.7514 139.364 116.336 116.206C133.061 96.9078 130.488 80.1827 131.775 63.4576C133.061 46.7325 153.646 41.5863 174.231 67.3172C194.816 91.7617 190.956 134.218 161.365 161.235Z"
            fill="#C5D3D9"
          />
          <path
            opacity="0.5238"
            d="M161.365 158.662C139.494 177.96 112.476 184.393 84.1724 174.101C45.576 158.662 43.0029 130.358 58.4415 127.785C71.3069 125.212 97.0379 140.65 117.623 116.206C134.348 96.9078 131.775 80.1827 133.061 63.4576C134.348 46.7325 153.646 42.8728 172.944 68.6038C192.242 91.7616 189.669 132.931 161.365 158.662Z"
            fill="#C0CED6"
          />
          <path
            opacity="0.5714"
            d="M160.079 157.376C139.494 176.674 112.477 183.107 86.7459 174.101C49.436 161.235 45.5763 132.931 59.7284 130.358C72.5938 127.785 98.3248 143.224 118.91 117.493C135.635 98.1944 133.062 81.4693 134.348 64.7442C134.348 49.3056 153.646 45.4459 171.658 69.8904C189.67 93.0482 187.097 131.645 160.079 157.376Z"
            fill="#BACAD2"
          />
          <path
            opacity="0.619"
            d="M158.792 154.802C139.494 174.101 113.763 180.533 88.0321 171.528C50.7222 159.949 46.8626 132.931 61.0146 130.358C72.5935 127.785 98.3245 144.51 121.482 117.493C138.207 98.1944 135.634 82.7558 135.634 66.0307C135.634 50.5921 153.646 46.7325 171.658 71.1769C187.096 93.0482 185.81 130.358 158.792 154.802Z"
            fill="#B4C5CE"
          />
          <path
            opacity="0.6667"
            d="M158.792 153.516C139.494 171.528 116.336 177.96 90.6052 171.528C54.5819 161.235 49.4357 135.504 62.3012 132.931C72.5936 130.358 99.611 147.083 122.769 120.066C139.494 99.4809 136.921 85.3289 136.921 68.6038C136.921 53.1652 153.646 50.5921 170.371 73.75C184.523 93.0482 183.237 129.072 158.792 153.516Z"
            fill="#AEC1CA"
          />
          <path
            opacity="0.7143"
            d="M157.506 150.943C139.494 168.955 117.623 175.387 93.1786 170.241C58.4418 161.235 52.009 136.791 63.588 134.218C73.8803 131.645 100.898 149.656 124.056 121.352C140.781 100.767 138.208 86.6155 136.921 69.8903C136.921 55.7383 152.36 51.8787 167.798 75.0365C181.95 94.3347 181.95 127.785 157.506 150.943Z"
            fill="#A9BDC7"
          />
          <path
            opacity="0.7619"
            d="M156.219 149.656C139.494 166.381 117.623 174.101 94.4651 168.955C61.0149 161.235 53.2956 138.077 64.8745 135.504C73.8803 132.931 102.184 150.943 125.342 121.352C142.067 100.767 139.494 86.6155 138.208 71.1769C136.921 57.0249 153.646 54.4518 166.512 76.3231C178.091 94.3348 179.377 125.212 156.219 149.656Z"
            fill="#A3B8C3"
          />
          <path
            opacity="0.8095"
            d="M154.933 147.083C138.208 163.808 118.91 171.528 97.0382 167.668C63.588 162.522 55.8687 140.65 66.1611 136.791C75.1669 134.218 103.471 153.516 126.629 122.639C143.354 102.054 139.494 87.902 138.208 72.4634C136.921 59.598 152.36 57.0249 165.225 77.6096C175.518 95.6213 178.091 123.925 154.933 147.083Z"
            fill="#9DB4BF"
          />
          <path
            opacity="0.8571"
            d="M154.933 145.797C139.494 162.522 121.482 168.955 99.611 166.381C67.4473 162.522 57.1549 141.937 67.4473 138.077C75.1666 135.504 103.471 154.802 129.202 123.925C145.927 103.341 142.067 89.1886 140.781 75.0365C139.494 62.1711 153.646 59.598 165.225 80.1827C172.944 95.6213 175.517 122.639 154.933 145.797Z"
            fill="#97AFBB"
          />
          <path
            opacity="0.9048"
            d="M153.646 143.224C139.494 158.662 121.483 166.381 100.898 165.095C70.0207 162.522 58.4418 143.224 68.7342 139.364C75.1669 136.791 104.757 157.376 130.488 125.212C147.214 104.627 143.354 90.4751 142.067 76.3231C140.781 64.7442 153.646 62.1711 163.939 81.4693C171.658 95.6213 174.231 121.352 153.646 143.224Z"
            fill="#92ABB8"
          />
          <path
            opacity="0.9524"
            d="M152.359 141.937C138.207 157.376 122.769 165.095 103.471 163.808C73.88 162.522 61.0146 144.51 70.0204 140.65C76.4531 138.077 106.044 158.662 131.775 125.212C148.5 104.627 144.64 90.4751 142.067 76.3231C140.781 64.7442 152.359 62.1711 161.365 81.4693C169.085 96.9078 171.658 120.066 152.359 141.937Z"
            fill="#8CA6B4"
          />
          <path
            d="M151.073 139.364C138.208 153.516 124.056 161.235 104.757 162.522C76.4533 163.808 62.3013 145.797 70.0206 141.937C75.1667 139.364 106.044 161.235 131.775 126.498C148.5 105.914 144.64 91.7617 142.067 78.8962C139.494 68.6038 152.36 66.0307 160.079 85.3289C166.512 96.9078 170.371 118.779 151.073 139.364Z"
            fill="#86A2B0"
          />
        </g>
        <path
          d="M162.652 102.054C162.652 135.504 135.634 162.522 102.184 162.522C68.734 162.522 41.7165 135.504 41.7165 102.054C41.7165 68.6038 68.734 41.5863 102.184 41.5863C135.634 41.5863 162.652 68.6038 162.652 102.054Z"
          fill="#FFE3AB"
        />
        <path
          d="M163.939 103.341C163.939 136.791 136.921 163.808 103.471 163.808C70.0205 163.808 43.0031 136.791 43.0031 103.341C43.0031 69.8904 70.0205 41.5863 103.471 41.5863C136.921 41.5863 163.939 69.8904 163.939 103.341Z"
          fill="url(#paint16_linear_2_192)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2_192"
            x1="92.3999"
            y1="17.4622"
            x2="113.894"
            y2="38.9566"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2_192"
            x1="92.4011"
            y1="167.263"
            x2="113.893"
            y2="188.756"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2_192"
            x1="17.4945"
            y1="92.3573"
            x2="38.9888"
            y2="113.854"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2_192"
            x1="167.3"
            y1="92.3573"
            x2="188.794"
            y2="113.854"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_2_192"
            x1="42.4309"
            y1="148.324"
            x2="57.9352"
            y2="163.829"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint5_linear_2_192"
            x1="148.358"
            y1="42.3967"
            x2="163.863"
            y2="57.901"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint6_linear_2_192"
            x1="140.947"
            y1="140.908"
            x2="171.275"
            y2="171.237"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint7_linear_2_192"
            x1="35.0196"
            y1="34.9809"
            x2="65.3496"
            y2="65.3109"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint8_linear_2_192"
            x1="161.138"
            y1="120.566"
            x2="183.552"
            y2="142.98"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint9_linear_2_192"
            x1="22.7348"
            y1="63.2363"
            x2="45.149"
            y2="85.6505"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint10_linear_2_192"
            x1="63.2753"
            y1="22.6959"
            x2="85.6921"
            y2="45.1127"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint11_linear_2_192"
            x1="120.597"
            y1="161.094"
            x2="143.017"
            y2="183.514"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint12_linear_2_192"
            x1="27.3059"
            y1="125.13"
            x2="40.5857"
            y2="138.409"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint13_linear_2_192"
            x1="165.707"
            y1="67.7971"
            x2="178.992"
            y2="81.082"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint14_linear_2_192"
            x1="67.8397"
            y1="165.665"
            x2="81.1246"
            y2="178.95"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint15_linear_2_192"
            x1="125.163"
            y1="27.2644"
            x2="138.449"
            y2="40.5506"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFBB31" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
          <linearGradient
            id="paint16_linear_2_192"
            x1="59.9662"
            y1="59.9286"
            x2="146.323"
            y2="146.286"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFD45C" />
            <stop offset="1" stopColor="#FF9D00" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default sunny;
